<template>
  <main class="main_plan_container">
    <header class="header_container">
      <section class="header_content clearfix">
        <a class="header_jetfi_logo"></a>
        <nav class="header_nav">
          <ul>
            <li class="languages">
              <a>
                <p class="choose" v-on:click="toggleLangList()">Language 語言</p>
                <div class="sub_item" v-if="showLangList">
                  <div class="sub_list">
                    <p v-on:click="changeLanguage('tw')">繁體中文</p>
                    <p v-on:click="changeLanguage('en')">English</p>
                    <!-- <p v-on:click="changeLanguage('ja')">日本語</p> -->
                  </div>
                </div>
              </a>
            </li>
            <!-- <li class="currency">
              <a>
                <p class="choose" v-on:click="toggleCurrencyList()">{{currency}}</p>
                <div class="sub_item" v-if="showCurrencyList">
                  <div class="sub_list">
                    <router-link to="/ntd"><p>{{$t("NTD")}}</p></router-link> 
                    <router-link to="/usd"><p>{{$t("USD")}}</p></router-link> 
                  </div>
                </div>
              </a>
            </li> -->
          </ul>
        </nav>
      </section>
    </header>
    <section class="area_content">
      <!-- <h3 class="top_title">{{$t("Data Store / Data Package")}}</h3> -->

      <!-- <a href="javascript:" v-on:click="changeLanguage('tw')">TW</a> -->
      <!-- <a href="javascript:" v-on:click="changeLanguage('en')">EN</a> -->
      <div class="area_menu">
        <!-- <div class="search_box">
					<input class="search_key_words" type="text" name="" placeholder="搜尋國家及地區">
        </div>-->
        <ul class="choose_area">
          <li>
            <p>{{ $t("country or region") }}：</p>
          </li>
          <li class="area_01">
            <p v-bind:class="{ btn_in: activeTab.asia }">
              <a v-on:click="changeTab('asia')" href="javascript:">{{$t("Asia")}}</a>
            </p>
          </li>
          <li class="area_02">
            <p v-bind:class="{ btn_in: activeTab.europe }">
              <a v-on:click="changeTab('europe')" href="javascript:">{{$t("Europe")}}</a>
            </p>
          </li>
          <li class="area_03">
            <p v-bind:class="{ btn_in: activeTab.africa }">
              <a v-on:click="changeTab('africa')" href="javascript:">{{$t("Africa")}}</a>
            </p>
          </li>
          <li class="area_04">
            <p v-bind:class="{ btn_in: activeTab.oceania }">
              <a v-on:click="changeTab('oceania')" href="javascript:">{{$t("Oceania")}}</a>
            </p>
          </li>
          <li class="area_05">
            <p v-bind:class="{ btn_in: activeTab.northAmerica }">
              <a v-on:click="changeTab('northAmerica')" href="javascript:">{{$t("North America")}}</a>
            </p>
          </li>
          <li class="area_06">
            <p v-bind:class="{ btn_in: activeTab.southAmerica }">
              <a v-on:click="changeTab('southAmerica')" href="javascript:">{{$t("South America")}}</a>
            </p>
          </li>
          <li class="area_07">
            <p v-bind:class="{ btn_in: activeTab.southAmerica }">
              <a v-on:click="changeTab('global')" href="javascript:">{{$t("Global")}}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'asia'"
          class="choose_country"
          id="area_01_content"
          style="display: block;"
        >
          <li class="top_hot_country">
            <p>
              {{$t("Popular Destinations")}}：
              <a
                href="javascript:"
                v-on:click="changeCountry('JP')"
              >{{$t("Japan")}}</a>
              <a href="javascript:" v-on:click="changeCountry('TH')">{{$t("Thailand")}}</a>
              <a href="javascript:" v-on:click="changeCountry('CN')">{{$t("China")}}</a>
              <a href="javascript:" v-on:click="changeCountry('HK')">{{$t("Hong Kong")}}</a>
            </p>
          </li>
          <li v-for="c in asia.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{$t(c.en)}}</a>
            </p>
          </li>
        </ul>
        <ul
          v-show="area === 'europe'"
          class="choose_country"
          id="area_01_content"
          style="display: block;"
        >
          <li class="top_hot_country">
            <p>
              {{$t("Popular Destinations")}}：
              <a
                href="javascript:"
                v-on:click="changeCountry('DE')"
              >{{$t("Germany")}}</a>
              <a href="javascript:" v-on:click="changeCountry('GB')">{{$t("United Kingdom")}}</a>
            </p>
          </li>
          <li v-for="c in europe.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{$t(c.en)}}</a>
            </p>
          </li>
        </ul>
        <ul v-show="area === 'africa'" class="choose_country" id="area_01_content">
          <li class="top_hot_country">
            <p>
              {{$t("Popular Destinations")}}：
              <a
                href="javascript:"
                v-on:click="changeCountry('EG')"
              >{{$t("Egypt")}}</a>
            </p>
          </li>
          <li v-for="c in africa.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{$t(c.en)}}</a>
            </p>
          </li>
        </ul>
        <ul v-show="area === 'oceania'" class="choose_country" id="area_01_content">
          <li v-for="c in oceania.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{$t(c.en)}}</a>
            </p>
          </li>
        </ul>
        <ul v-show="area === 'northAmerica'" class="choose_country" id="area_01_content">
          <li class="top_hot_country">
            <p>
              {{$t("Popular Destinations")}}：
              <a
                href="javascript:"
                v-on:click="changeCountry('US')"
              >{{$t("United States")}}</a>
            </p>
          </li>
          <li v-for="c in northAmerica.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{$t(c.en)}}</a>
            </p>
          </li>
        </ul>
        <ul v-show="area === 'southAmerica'" class="choose_country" id="area_01_content">
          <li v-for="c in southAmerica.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{$t(c.en)}}</a>
            </p>
          </li>
        </ul>
        <ul v-show="area === 'global'" class="choose_country" id="area_01_content">
          <li v-for="c in global.countries" v-bind:key="c.code">
            <p>
              <a href="javascript:" v-on:click="changeCountry(c.code)">{{$t(c.en)}}</a>
            </p>
          </li>
        </ul>
      </div>
    </section>
    <section class="set_content">
      <h3 class="top_title">{{$t("Unlimited / Data Package")}}</h3>
      <ul class="menu_list clearfix">
        <!-- <li v-for="item in plans[currency][language][selectedCountry]" v-bind:key="item.id"> -->
        <li v-for="item in selectedPlans[selectedCountry]" v-bind:key="item.id">

          <a v-if="distributor && replaceMap[distributor][item.title]" v-bind:href="replaceMap[distributor][item.title].url">
            <h4 class="set_title">{{item.title}}</h4>
            <p class="label">
              <span v-for="l in item.labels" v-bind:key="l">{{l}}</span>
            </p>
            <p class="price">{{replaceMap[distributor][item.title].price}}</p>
          </a>
          <a v-else v-bind:href="item.url">
            <h4 class="set_title">{{item.title}}</h4>
            <p class="label">
              <span v-for="l in item.labels" v-bind:key="l">{{l}}</span>
            </p>
            <p class="price">{{item.price}}</p>
          </a>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
export default {
  name: "Taiwan",
  data() {
    return {
      distributor: null,
      replaceMap: {
        'cal': { // 華航
          '全球85國10GB': {
            price: "NTD 2200",
            url: "https://dl.gl/okMNoEYew"
          },
          'Global 85 countries 10GB package': {
            price: "NTD 2200",
            url: "https://dl.gl/okMNoEYew"
          }
        },
        'eva': {
          '全球85國10GB': {
            price: "NTD 1350",
            url: "https://dl.gl/ll2RonNXE"
          },
          'Global 85 countries 10GB package': {
            price: "NTD 1350",
            url: "https://dl.gl/ll2RonNXE"
          }
        }
      },
      area: "asia",
      activeTab: {
        asia: true,
        europe: false,
        africa: false,
        oceania: false,
        northAmerica: false,
        southAmerica: false,
        global: false
      },
      showLangList: false,
      showCurrencyList: false,
      selectedCountry: "JP",
      language: "tw",
      currency: "NTD",
      selectedPlans: {},
      asia: {
        countries: [
          { code: "TW", en: "Taiwan", "zh-TW": "台灣" },
          { code: "JP", en: "Japan", "zh-TW": "日本" },
          { code: "KR", en: "Korea", "zh-TW": "韓國" },
          { code: "CN", en: "China", "zh-TW": "中國" },
          { code: "HK", en: "Hong Kong", "zh-TW": "香港" },
          { code: "MO", en: "Macao", "zh-TW": "澳門" },
          { code: "SG", en: "Singapore", "zh-TW": "新加坡" },
          { code: "MY", en: "Malaysia", "zh-TW": "馬來西亞" },
          { code: "TH", en: "Thailand", "zh-TW": "泰國" },
          { code: "VN", en: "VietNam", "zh-TW": "越南" },
          { code: "ID", en: "Indonesia", "zh-TW": "印尼" },
          { code: "PH", en: "Philippines", "zh-TW": "菲律賓" },
          { code: "KH", en: "Cambodia", "zh-TW": "柬埔寨" },
          { code: "LA", en: "Laos", "zh-TW": "寮國" },
          { code: "MM", en: "Myanmar", "zh-TW": "緬甸" },
          { code: "IN", en: "India", "zh-TW": "印度" },
          { code: "IL", en: "Israel", "zh-TW": "以色列" },
          { code: "BD", en: "Bangladesh", "zh-TW": "孟加拉" },
          { code: "LK", en: "Sri Lanka", "zh-TW": "斯里蘭卡" },
          { code: "NP", en: "Nepal", "zh-TW": "尼泊爾" },
          { code: "JO", en: "Jordan", "zh-TW": "約旦" },
          { code: "MN", en: "Mongolia", "zh-TW": "外蒙古" },
          { code: "QA", en: "Qatar", "zh-TW": "卡達" },
          { code: "SA", en: "Saudi Arabia", "zh-TW": "沙烏地阿拉伯" },
          { code: "BN", en: "Brunei", "zh-TW": "汶萊" },
          { code: "MV", en: "Maldives", "zh-TW": "馬爾地夫" },
          { code: "BH", en: "Bahrain", "zh-TW": "巴林" },
          { code: "PK", en: "Pakistan", "zh-TW": "巴基斯坦" },
          { code: "KZ", en: "Kazakhstan", "zh-TW": "哈薩克" },
          { code: "AE", en: "UAE", "zh-TW": "阿拉伯聯合大公國" },
          { code: "AZ", en: "Azerbaijan", "zh-TW": "亞塞拜然" },
          { code: "AM", en: "Armenia", "zh-TW": "亞美尼亞" },
          { code: "GE", en: "Georgia", "zh-TW": "喬治亞" },
          { code: "OM", en: "Oman", "zh-TW": "阿曼" },
          { code: "KW", en: "Kuwait", "zh-TW": "科威特" },
          { code: "TJ", en: "Tajikistan", "zh-TW": "塔吉克" }
        ]
      },
      europe: {
        countries: [
          { code: "AT", en: "Austria", "zh-TW": "奧地利" },
          { code: "BG", en: "Bulgaria", "zh-TW": "保加利亞" },
          { code: "CH", en: "Switzerland", "zh-TW": "瑞士" },
          { code: "CZ", en: "Czech Republic", "zh-TW": "捷克共和國" },
          { code: "DE", en: "Germany", "zh-TW": "德國" },
          { code: "DK", en: "Denmark", "zh-TW": "丹麥" },
          { code: "EE", en: "Estonia", "zh-TW": "愛沙尼亞" },
          { code: "ES", en: "Spain", "zh-TW": "西班牙" },
          { code: "FI", en: "Finland", "zh-TW": "芬蘭" },
          { code: "FR", en: "France", "zh-TW": "法國" },
          { code: "GB", en: "United Kingdom", "zh-TW": "英國" },
          { code: "HR", en: "Croatia", "zh-TW": "克羅埃西亞" },
          { code: "IE", en: "Ireland", "zh-TW": "愛爾蘭" },
          { code: "IS", en: "Iceland", "zh-TW": "冰島" },
          { code: "IT", en: "Italy", "zh-TW": "義大利" },
          { code: "LV", en: "Latvia", "zh-TW": "拉脫維亞" },
          { code: "MT", en: "Malta", "zh-TW": "馬爾他" },
          { code: "NO", en: "Norway", "zh-TW": "挪威" },
          { code: "PL", en: "Poland", "zh-TW": "波蘭" },
          { code: "PT", en: "Portugal", "zh-TW": "葡萄牙" },
          { code: "RO", en: "Romania", "zh-TW": "羅馬尼亞" },
          { code: "RU", en: "Russia", "zh-TW": "俄羅斯" },
          { code: "SE", en: "Sweden", "zh-TW": "瑞典" },
          { code: "SI", en: "Slovenia", "zh-TW": "斯洛維尼亞" },
          { code: "SK", en: "Slovakia", "zh-TW": "斯洛伐克" },
          { code: "TR", en: "Turkey", "zh-TW": "土耳其" },
          { code: "UA", en: "Ukraine", "zh-TW": "烏克蘭" },
          { code: "LI", en: "Liechtenstein", "zh-TW": "列支敦士登" },
          { code: "VA", en: "Vatican", "zh-TW": "梵蒂岡" },
          { code: "MC", en: "Monaco", "zh-TW": "摩納哥" },
          { code: "AX", en: "Åland Islands", "zh-TW": "奧蘭群島" },
          { code: "SM", en: "San Marino", "zh-TW": "聖馬利諾" },
          { code: "NL", en: "Netherlands", "zh-TW": "荷蘭" },
          { code: "BE", en: "Belgium", "zh-TW": "比利時" },
          { code: "LU", en: "Luxembourg", "zh-TW": "盧森堡" },
          { code: "CY", en: "Cyprus", "zh-TW": "賽普勒斯" },
          { code: "GR", en: "Greece", "zh-TW": "希臘" },
          { code: "HU", en: "Hungary", "zh-TW": "匈牙利" },
          { code: "LT", en: "Lithuania", "zh-TW": "立陶宛" },
          { code: "RS", en: "Serbia", "zh-TW": "塞爾維亞" },
          { code: "ME", en: "Montenegro", "zh-TW": "蒙特內哥羅" },
          { code: "GG", en: "Guernsey", "zh-TW": "根西島" },
          { code: "JE", en: "Jersey", "zh-TW": "澤西島" },
          { code: "IM", en: "Isle of man", "zh-TW": "曼島" },
          {
            code: "BA",
            en: "Bosnia and Herzegovina",
            "zh-TW": "波士尼亞赫塞哥維納"
          },
          { code: "GI", en: "Gibraltar", "zh-TW": "直布羅陀" },
          { code: "AL", en: "Albania", "zh-TW": "阿爾巴尼亞" },
          { code: "MK", en: "Macedonia", "zh-TW": "馬其頓" }
        ]
      },
      africa: {
        countries: [
          { code: "EG", en: "Egypt", "zh-TW": "埃及" },
          { code: "MA", en: "Morocco", "zh-TW": "摩洛哥" },
          { code: "KE", en: "Kenya", "zh-TW": "肯亞" },
          { code: "EH", en: "Western Sahara", "zh-TW": "西撒哈拉" },
          { code: "GH", en: "Ghana", "zh-TW": "迦納" },
          { code: "ZA", en: "South Africa", "zh-TW": "南非" },
          { code: "MG", en: "Madagascar", "zh-TW": "馬達加斯加" },
          { code: "DZ", en: "Algeria", "zh-TW": "阿爾及利亞" },
          { code: "ZM", en: "Zambia", "zh-TW": "尚比亞" },
          { code: "MU", en: "Mauritius", "zh-TW": "模里西斯" },
          { code: "NG", en: "Nigeria", "zh-TW": "奈及利亞" },
          { code: "TN", en: "Tunisia", "zh-TW": "突尼斯" },
          { code: "TZ", en: "Tanzania", "zh-TW": "坦尚尼亞" },
          { code: "AO", en: "Angola", "zh-TW": "安哥拉" }
        ]
      },
      oceania: {
        countries: [
          { code: "AU", en: "Australia", "zh-TW": "澳洲" },
          { code: "NZ", en: "New Zealand", "zh-TW": "紐西蘭" },
          { code: "FJ", en: "Fiji", "zh-TW": "斐濟" },
          { code: "GU", en: "Guam", "zh-TW": "關島" },
          { code: "MP", en: "Saipan", "zh-TW": "塞班" }
        ]
      },
      northAmerica: {
        countries: [
          { code: "US", en: "United States", "zh-TW": "美國" },
          { code: "CA", en: "Canada", "zh-TW": "加拿大" },
          { code: "MX", en: "Mexico", "zh-TW": "墨西哥" },
          { code: "PR", en: "Puerto Rico", "zh-TW": "波多黎各" },
          { code: "GP", en: "Guadeloupe", "zh-TW": "瓜德魯普" },
          { code: "MF", en: "Saint Martin", "zh-TW": "聖馬丁" },
          { code: "AG", en: "Antigua and Barbuda", "zh-TW": "安地卡及巴布達" },
          { code: "AW", en: "Aruba", "zh-TW": "阿魯巴" },
          { code: "KY", en: "Cayman Islands", "zh-TW": "開曼群島" },
          { code: "CW", en: "Curacao", "zh-TW": "庫拉索島" },
          { code: "GD", en: "Grenada", "zh-TW": "格瑞那達" },
          { code: "HT", en: "Haiti", "zh-TW": "海地" },
          { code: "JM", en: "Jamaica", "zh-TW": "牙買加" },
          { code: "TT", en: "Trinidad and Tobago", "zh-TW": "千里達" },
          {
            code: "TC",
            en: "Turks and Caicos Islands",
            "zh-TW": "特克斯和凱科斯群島"
          },
          { code: "MQ", en: "Martinique", "zh-TW": "法屬馬丁尼克" },
          { code: "AI", en: "Anguilla", "zh-TW": "安圭拉" },
          { code: "VG", en: "British Virgin Islands", "zh-TW": "英屬維京群島" },
          {
            code: "VC",
            en: "Saint Vincent and the Grenadines",
            "zh-TW": "聖文森特及格林納丁斯"
          }
        ]
      },
      southAmerica: {
        countries: [
          { code: "AR", en: "Argentina", "zh-TW": "阿根廷" },
          { code: "BR", en: "Brazil", "zh-TW": "巴西" },
          { code: "PE", en: "Peru", "zh-TW": "秘魯" },
          { code: "CO", en: "Colombia", "zh-TW": "哥倫比亞" },
          { code: "UY", en: "Uruguay", "zh-TW": "烏拉圭" },
          { code: "VE", en: "Venezuela", "zh-TW": "委內瑞拉" },
          { code: "GY", en: "Guyana", "zh-TW": "圭亞那" },
          { code: "PA", en: "Panama", "zh-TW": "巴拿馬" },
          { code: "CL", en: "Chile", "zh-TW": "智利" },
          { code: "BO", en: "Bolivia", "zh-TW": "玻利維亞" },
          { code: "CR", en: "Costa Rica", "zh-TW": "哥斯大黎加" },
          { code: "SR", en: "Suriname", "zh-TW": "蘇利南" },
          { code: "EC", en: "Ecuador", "zh-TW": "厄瓜多爾" },
          {
            code: "DO",
            en: "The Dominican Republic",
            "zh-TW": "多明尼加共和國"
          },
          { code: "GT", en: "Guatemala", "zh-TW": "瓜地馬拉" },
          { code: "NI", en: "Nicaragua", "zh-TW": "尼加拉瓜" },
          { code: "SV", en: "El Salvador", "zh-TW": "薩爾瓦多" }
        ]
      },
      global: {
        countries: [{ code: "GLOBAL", en: "Global", "zh-TW": "全球" }]
      },
      plans: {
        NTD: {
          tw: {
            GLOBAL: [
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TW: [
              {
                title: "台灣 吃到飽 套餐",
                price: "NTD 69",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/MKkNon7ep",
                code: "Taiwan"
              },
              {
                title: "流量加值 台灣上網14天吃到飽",
                price: "NTD 300",
                labels: ["14天", "吃到飽"],
                url: "https://dl.gl/ARX8NLD17",
                code: "Taiwan"
              },
              {
                title: "流量加值 台灣上網30天吃到飽",
                price: "NTD 390",
                labels: ["30天", "吃到飽"],
                url: "https://dl.gl/RLY0550BJ",
                code: "Taiwan"
              }
            ],
            JP: [
              {
                title: "日本 單國套餐",
                price: "NTD 69",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/1aKma2Y9O"
              },
              {
                title: "日韓吃到飽",
                price: "NTD 69",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/BpyALBbgk"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            KR: [
              {
                title: "韓國 單國套餐",
                price: "NTD 69",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/LL3a6LmlN"
              },
              {
                title: "日韓吃到飽",
                price: "NTD 69",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/BpyALBbgk"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CN: [
              {
                title: "中國 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/Nlb8R8ZdZ"
              },
              {
                title: "中國 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/LL3a8mXJv"
              },
              {
                title: "中國 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/aNXYk4XaQ"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "中國+東南亞6國",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "中俄500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ynl8wmB4L"
              },
              {
                title: "中俄1GB",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/aNXYkeXZQ"
              },
              {
                title: "中俄吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/Oo5LRvOzL"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            HK: [
              {
                title: "香港 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ZENYQYK72"
              },
              {
                title: "香港 單國套餐",
                price: "NTD 139",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/1aKmAaOk6"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MO: [
              {
                title: "澳門 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/nVG1P1zwL"
              },
              {
                title: "澳門 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/5Qd7o7DDB"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SG: [
              {
                title: "新加坡 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/QVlaVBe4Q"
              },
              {
                title: "新加坡 單國套餐",
                price: "NTD 99",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/pVnA1Vp8l"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "新馬泰越吃到飽",
                price: "NTD 99",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/J4w6YG1KD"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MY: [
              {
                title: "馬來西亞 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/dRo6O6Xwy"
              },
              {
                title: "馬來西亞 單國套餐",
                price: "NTD 99",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/LL3a6LBvv"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "新馬泰越吃到飽",
                price: "NTD 99",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/J4w6YG1KD"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TH: [
              {
                title: "泰國 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/AAYRzJkN7"
              },
              {
                title: "泰國 單國套餐",
                price: "NTD 99",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/vmb1OmzMl"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "新馬泰越吃到飽",
                price: "NTD 99",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/J4w6YG1KD"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            VN: [
              {
                title: "越南 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ZENYQYgl9"
              },
              {
                title: "越南 單國套餐",
                price: "NTD 99",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/RLDm4Lr6J"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "新馬泰越吃到飽",
                price: "NTD 99",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/J4w6YG1KD"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            ID: [
              {
                title: "印尼 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/Nlb8R8Eml"
              },
              {
                title: "印尼 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28R4l0z"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "中國+東南亞6國",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PH: [
              {
                title: "菲律賓 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/VY8m4mvka"
              },
              {
                title: "菲律賓 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/ynl8w8AoL"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "中國+東南亞6國",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            KH: [
              {
                title: "柬埔寨 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/wG5mPDRQz"
              },
              {
                title: "柬埔寨 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/6bZX1BaBy"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "中國+東南亞6國",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LA: [
              {
                title: "寮國 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/llLXPXaYB"
              },
              {
                title: "寮國 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RK9rl"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "中國+東南亞6國",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MM: [
              {
                title: "緬甸 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/brmRvR0Pp"
              },
              {
                title: "緬甸 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/QVladVRJo"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "中國+東南亞6國",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IN: [
              {
                title: "印度 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/796DmD7KD"
              },
              {
                title: "印度 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RKY51"
              },
              {
                title: "中國+東南亞10國",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "中國+東南亞6國",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IL: [
              {
                title: "以色列 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/9KXv9vEZ1"
              },
              {
                title: "以色列 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/6bZXmbGJy"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BD: [
              {
                title: "孟加拉 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/kLgMbMlnY"
              },
              {
                title: "孟加拉 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/2rNd0rrKO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LK: [
              {
                title: "斯里蘭卡 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/dRo6O6pGZ"
              },
              {
                title: "斯里蘭卡 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/RLDm4Lkwn"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            NP: [
              {
                title: "尼泊爾 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/2rNd0d5X4"
              },
              {
                title: "尼泊爾 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/llLXgYkEa"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            JO: [
              {
                title: "約旦 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/QVladazp0"
              },
              {
                title: "約旦 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/J4w6Y4nMG"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MN: [
              {
                title: "外蒙古 單國套餐",
                price: "NTD 80",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/Epz8L8BQJ"
              },
              {
                title: "外蒙古 單國套餐",
                price: "NTD 155",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/dRo6OR6BY"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            QA: [
              {
                title: "卡達 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/Oo5LRLMM8"
              },
              {
                title: "卡達 單國套餐",
                price: "NTD 219",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/4aA0zaZ5y"
              }
            ],
            SA: [
              {
                title: "沙烏地阿拉伯 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/4aA0z0MJK"
              },
              {
                title: "沙烏地阿拉伯 單國套餐",
                price: "NTD 219",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/LL3a6LpM5"
              }
            ],
            BN: [
              {
                title: "汶萊 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/4aA0z04Yz"
              },
              {
                title: "汶萊 單國套餐",
                price: "NTD 219",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/QVladV2BR"
              }
            ],
            MV: [
              {
                title: "馬爾地夫 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/J4w6Y6aBp"
              },
              {
                title: "馬爾地夫 單國套餐",
                price: "NTD 219",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/QVladVG00"
              }
            ],
            BH: [
              {
                title: "巴林 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/BpyALAp5K"
              },
              {
                title: "巴林 單國套餐",
                price: "NTD 219",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/5Qd7oQgYl"
              }
            ],
            PK: [
              {
                title: "巴基斯坦 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/G4OpLpmbZ"
              },
              {
                title: "巴基斯坦 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/kLgMbL8p3"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            KZ: [
              {
                title: "哈薩克 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/5Qd7oQRYa"
              },
              {
                title: "哈薩克 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/4aA0zarrZ"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AE: [
              {
                title: "阿拉伯聯合大公國 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/pVnA1Vklw"
              },
              {
                title: "阿拉伯聯合大公國 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/J4w6Y4GKa"
              }
            ],
            AZ: [
              {
                title: "亞塞拜然 單國套餐",
                price: "NTD 189",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/2rNd0apre"
              },
              {
                title: "亞塞拜然 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/6bZXmbbNy"
              }
            ],
            AM: [
              {
                title: "亞美尼亞 單國套餐",
                price: "NTD 189",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/nVG1PV28J"
              },
              {
                title: "亞美尼亞 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/Nlb8R47ze"
              }
            ],
            GE: [
              {
                title: "喬治亞 單國套餐",
                price: "NTD 189",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/zeD9EeAG2"
              },
              {
                title: "喬治亞 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/vmb1OmLwK"
              }
            ],
            OM: [
              {
                title: "阿曼 單國套餐",
                price: "NTD 219",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ynl8wno6l"
              },
              {
                title: "阿曼 單國套餐",
                price: "NTD 339",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/Epz8La50v"
              }
            ],
            KW: [
              {
                title: "科威特 單國套餐",
                price: "NTD 219",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/llLXPlMok"
              },
              {
                title: "科威特 單國套餐",
                price: "NTD 339",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/nVG1P8GBJ"
              }
            ],
            TJ: [
              {
                title: "塔吉克 單國套餐",
                price: "NTD 279",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/aNXYkNpPk"
              },
              {
                title: "塔吉克 單國套餐",
                price: "NTD 459",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/2rNd0OmQO"
              }
            ],
            AT: [
              {
                title: "奧地利 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/0opLBL3bp"
              },
              {
                title: "奧地利 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/PVMZLvwKB"
              },
              {
                title: "奧地利 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/J4w6Yv0LD"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BG: [
              {
                title: "保加利亞 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/G4OpLpozR"
              },
              {
                title: "保加利亞 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "ttps://dl.gl/nVG1P85B4"
              },
              {
                title: "保加利亞 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/9KXv9oEB1"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CH: [
              {
                title: "瑞士 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/pVnA1AQ1l"
              },
              {
                title: "瑞士 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/RLDm49DAm"
              },
              {
                title: "瑞士 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/YmKYAB8lB"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CZ: [
              {
                title: "捷克共和國 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/PVMZLZkmO"
              },
              {
                title: "捷克共和國 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/4aA0zd9l8"
              },
              {
                title: "捷克共和國 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/kLgMbR9zQ"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            DE: [
              {
                title: "德國 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/vmb1O18gY"
              },
              {
                title: "德國 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/LL3a6KN0M"
              },
              {
                title: "德國 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/RLDm49KRn"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            DK: [
              {
                title: "丹麥 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/829ama3eE"
              },
              {
                title: "丹麥 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/5Qd7o0yOG"
              },
              {
                title: "丹麥 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/1aKmAGVwr"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            EE: [
              {
                title: "愛沙尼亞 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/rRw1APLK5"
              },
              {
                title: "愛沙尼亞 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/llLXPm2Gr"
              },
              {
                title: "愛沙尼亞 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/KbEmRmKyp"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            ES: [
              {
                title: "西班牙 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/gmPzwzKNz"
              },
              {
                title: "西班牙 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/gmPzwN69l"
              },
              {
                title: "西班牙 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/KbEmRv81Y"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            FI: [
              {
                title: "芬蘭 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/829amaywO"
              },
              {
                title: "芬蘭 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/brmRvyBXm"
              },
              {
                title: "芬蘭 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/5Qd7oZkAa"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            FR: [
              {
                title: "法國 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/brmRvRNYK"
              },
              {
                title: "法國 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/2rNd0O2JJ"
              },
              {
                title: "法國 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/llLXV0KmO"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            GB: [
              {
                title: "英國 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/zeD9E9N7O"
              },
              {
                title: "英國 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/2rNd0O8A1"
              },
              {
                title: "英國 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/3badobXA0"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            HR: [
              {
                title: "克羅埃西亞 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ynl8w8Dy6"
              },
              {
                title: "克羅埃西亞 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/J4w6982yp"
              },
              {
                title: "克羅埃西亞 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/QVla3Z2MX"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IE: [
              {
                title: "愛爾蘭 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/vmb1O1zY2"
              },
              {
                title: "愛爾蘭 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/YmKYABZpV"
              },
              {
                title: "愛爾蘭 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/e8r2n1oDZ"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IS: [
              {
                title: "冰島 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/QVladZRNQ"
              },
              {
                title: "冰島 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/pVnA1PrBO"
              },
              {
                title: "冰島 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/wG5mnAZ6V"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IT: [
              {
                title: "義大利 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/1aKmAmk2g"
              },
              {
                title: "義大利 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/e8r2n1N19"
              },
              {
                title: "義大利 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/gmPzwDgvD"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LV: [
              {
                title: "拉脫維亞 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/LL3a6aO4m"
              },
              {
                title: "拉脫維亞 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/ynl8wbR3l"
              },
              {
                title: "拉脫維亞 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/PVMZLGRzL"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MT: [
              {
                title: "馬爾他 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/BpyAlm9G6"
              },
              {
                title: "馬爾他 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/Nlb8R4mbb"
              },
              {
                title: "馬爾他 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/kLgMbR433"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            NO: [
              {
                title: "挪威 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: 'link":"https://dl.gl/ynl8w84LB'
              },
              {
                title: "挪威 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/rRw1KRovY"
              },
              {
                title: "挪威 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/KbEmRvgve"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PL: [
              {
                title: "波蘭 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/5Qd7o75Ma"
              },
              {
                title: "波蘭 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/6bZXmdblp"
              },
              {
                title: "波蘭 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/e8r2n1arw"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PT: [
              {
                title: "葡萄牙 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2n2BBb"
              },
              {
                title: "葡萄牙 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/5Qd7o0DV7"
              },
              {
                title: "葡萄牙 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/pVnA1P8bQ"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            RO: [
              {
                title: "羅馬尼亞 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/5Qd7p2bz5"
              },
              {
                title: "羅馬尼亞 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28ReK0g"
              },
              {
                title: "羅馬尼亞 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/kLgMbRZ07"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            RU: [
              {
                title: "俄羅斯 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/6bZXmXvAD"
              },
              {
                title: "俄羅斯 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/J4w6YGK6Z"
              },
              {
                title: "俄羅斯 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/brmRvy3Yr"
              },
              {
                title: "中俄500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ynl8wmB4L"
              },
              {
                title: "中俄1GB",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/aNXYkeXZQ"
              },
              {
                title: "中俄吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/Oo5LRvOzL"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SE: [
              {
                title: "瑞典 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/6bZXm79GQ"
              },
              {
                title: "瑞典 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/3badonp4p"
              },
              {
                title: "瑞典 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/aNXYnGplv"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SI: [
              {
                title: "斯洛維尼亞 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/9KXv9v1w8"
              },
              {
                title: "斯洛維尼亞 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRMzKLX"
              },
              {
                title: "斯洛維尼亞 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/wG5mnAZAN"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SK: [
              {
                title: "斯洛伐克 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/6bZXmX89X"
              },
              {
                title: "斯洛伐克 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/wG5mnArBG"
              },
              {
                title: "斯洛伐克 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/RLDm2BYg4"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TR: [
              {
                title: "土耳其 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/1aKmAmvwv"
              },
              {
                title: "土耳其 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/Oo5LR9RdL"
              },
              {
                title: "土耳其 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/llLXPRkPE"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            UA: [
              {
                title: "烏克蘭 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/brmRvRdQ8"
              },
              {
                title: "烏克蘭 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRL02yX"
              },
              {
                title: "烏克蘭 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/aNXYnkZw1"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LI: [
              {
                title: "列支敦士登 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/QVladaNZl"
              },
              {
                title: "列支敦士登 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/1aKmAGO9v"
              },
              {
                title: "列支敦士登 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/XvpYJokmO"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            VA: [
              {
                title: "梵蒂岡 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/gmPzwz5Dz"
              },
              {
                title: "梵蒂岡 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/3badono70"
              },
              {
                title: "梵蒂岡 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/3badonPym"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MC: [
              {
                title: "摩納哥 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/llLXPX7Pr"
              },
              {
                title: "摩納哥 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/aNXYk4Dov"
              },
              {
                title: "摩納哥 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/vmb1OLavG"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AX: [
              {
                title: "奧蘭群島 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/aNXYkYmrQ"
              },
              {
                title: "奧蘭群島 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/e8r2n1k59"
              },
              {
                title: "奧蘭群島 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/4aA0RQZ58"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SM: [
              {
                title: "聖馬利諾 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/brmRvR298"
              },
              {
                title: "聖馬利諾 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/BpyALmXJm"
              },
              {
                title: "聖馬利諾 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/LL3aO9dZg"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            NL: [
              {
                title: "荷蘭 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/m1zLMLOp9"
              },
              {
                title: "荷蘭 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/LL3a6KBym"
              },
              {
                title: "荷蘭 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/3badoneG0"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BE: [
              {
                title: "比利時 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/1aKmAmA0Z"
              },
              {
                title: "比利時 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/ynl8wG2a6"
              },
              {
                title: "比利時 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/brmRvy9rr"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LU: [
              {
                title: "盧森堡 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/llLXPXy7o"
              },
              {
                title: "盧森堡 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/m1zLkYEJ9"
              },
              {
                title: "盧森堡 單國套餐",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/QVladOgPk"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "歐洲35國吃到飽",
                price: "NTD 250",
                labels: ["1天", "吃到飽"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CY: [
              {
                title: "賽普勒斯 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/wG5mnmyrg"
              },
              {
                title: "賽普勒斯 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/4aA0zdLEN"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            GR: [
              {
                title: "希臘 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ZENYQY8KN"
              },
              {
                title: "希臘 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/vmb1OLm0G"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            HU: [
              {
                title: "匈牙利 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/kLgMbMplQ"
              },
              {
                title: "匈牙利 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/XvpYJeOVD"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LT: [
              {
                title: "立陶宛 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/Epz8L8nYw"
              },
              {
                title: "立陶宛 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/brmRvamV0"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            RS: [
              {
                title: "塞爾維亞 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/AAYRME8ZK"
              },
              {
                title: "塞爾維亞 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/VY8m4P8Ja"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            ME: [
              {
                title: "蒙特內哥羅 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/AAYRLREPX"
              },
              {
                title: "蒙特內哥羅 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/kLgMbY9m1"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            GG: [
              {
                title: "根西島 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/Nlb8R8OmO"
              },
              {
                title: "根西島 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/aNXYkRPVZ"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            JE: [
              {
                title: "澤西島 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/rRw1A1A4L"
              },
              {
                title: "澤西島 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/nVG1PmwrY"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IM: [
              {
                title: "曼島 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ZENYQY8Jv"
              },
              {
                title: "曼島 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/829am699Y"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BA: [
              {
                title: "波士尼亞赫塞哥維納 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/1aKmAebLv"
              },
              {
                title: "波士尼亞赫塞哥維納 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/3badoQzKp"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            GI: [
              {
                title: "直布羅陀 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoEMap"
              },
              {
                title: "直布羅陀 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/829am67K2"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            AL: [
              {
                title: "阿爾巴尼亞 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/XvpYJvZkQ"
              },
              {
                title: "阿爾巴尼亞 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/Epz8Ll28g"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MK: [
              {
                title: "馬其頓 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/LL3a6Llb7"
              },
              {
                title: "馬其頓 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/Epz8LlPgy"
              },
              {
                title: "歐洲48國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "歐洲48國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            EG: [
              {
                title: "埃及 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badodnzQ"
              },
              {
                title: "埃及 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/llLXP6ayo"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MA: [
              {
                title: "摩洛哥 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/kLgMbML81"
              },
              {
                title: "摩洛哥 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/1aKmArwGO"
              }
            ],
            KE: [
              {
                title: "肯亞 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/QVladVBJ0"
              },
              {
                title: "肯亞 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/Oo5LRvDN8"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            EH: [
              {
                title: "西撒哈拉 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/okODLkVNJ"
              },
              {
                title: "西撒哈拉 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/G4OpLmkRM"
              }
            ],
            GH: [
              {
                title: "迦納 單國套餐",
                price: "NTD 189",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/G4Op8NR6M"
              },
              {
                title: "迦納 單國套餐",
                price: "NTD 369",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/BpyALdk71"
              }
            ],
            ZA: [
              {
                title: "南非 單國套餐",
                price: "NTD 189",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/796Dm9l5D"
              },
              {
                title: "南非 單國套餐",
                price: "NTD 369",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/e8r2nMJ8v"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MG: [
              {
                title: "馬達加斯加 單國套餐",
                price: "NTD 189",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badobwop"
              },
              {
                title: "馬達加斯加 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/wG5mnXVVz"
              }
            ],
            DZ: [
              {
                title: "阿爾及利亞 單國套餐",
                price: "NTD 219",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/dRo6ORVX1"
              },
              {
                title: "阿爾及利亞 單國套餐",
                price: "NTD 399",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/dRo6ONAeV"
              }
            ],
            ZM: [
              {
                title: "尚比亞 單國套餐",
                price: "NTD 249",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/brmRvr4Qw"
              },
              {
                title: "尚比亞 單國套餐",
                price: "NTD 429",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/6bZXmdBLm"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MU: [
              {
                title: "模里西斯 單國套餐",
                price: "NTD 309",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/G4OpL4mnZ"
              },
              {
                title: "模里西斯 單國套餐",
                price: "NTD 549",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/LL3a6vgbz"
              }
            ],
            NG: [
              {
                title: "奈及利亞 單國套餐",
                price: "NTD 309",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badobA01"
              },
              {
                title: "奈及利亞 單國套餐",
                price: "NTD 549",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/5Qd7oAOK7"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TN: [
              {
                title: "突尼斯 單國套餐",
                price: "NTD 309",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/G4OpL4ezZ"
              },
              {
                title: "突尼斯 單國套餐",
                price: "NTD 549",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/J4w6YGEzZ"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TZ: [
              {
                title: "坦尚尼亞 單國套餐",
                price: "NTD 309",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/zeD9EePB2"
              },
              {
                title: "坦尚尼亞 單國套餐",
                price: "NTD 549",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/XvpYJenOK"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AO: [
              {
                title: "安哥拉 單國套餐",
                price: "NTD 459",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2n8YEk"
              },
              {
                title: "安哥拉 單國套餐",
                price: "NTD 789",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/zeD9E5z43"
              }
            ],
            AU: [
              {
                title: "澳洲 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/gmPzwzzKD"
              },
              {
                title: "澳洲 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/brmRva6Vn"
              },
              {
                title: "紐澳斐3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ"
              },
              {
                title: "紐澳斐3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/okODLme9G"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            NZ: [
              {
                title: "紐西蘭 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/llLXPX55g"
              },
              {
                title: "紐西蘭 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/gmPzwYZ8w"
              },
              {
                title: "紐澳斐3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ"
              },
              {
                title: "紐澳斐3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/okODLme9G"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            FJ: [
              {
                title: "斐濟 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/9KXv9vKQ4"
              },
              {
                title: "斐濟 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/PVMZP7Va9"
              },
              {
                title: "紐澳斐3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ"
              },
              {
                title: "紐澳斐3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/okODLme9G"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            GU: [
              {
                title: "關島 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/YmKYAYaNP"
              },
              {
                title: "關島 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/okODLmemw"
              },
              {
                title: "關島塞班500MB",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoQZNY"
              },
              {
                title: "關島塞班1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/5Qd7oAMnZ"
              }
            ],
            MP: [
              {
                title: "塞班 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/brmRvrX9w"
              },
              {
                title: "塞班 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/XvpYJe9LP"
              },
              {
                title: "關島塞班500MB",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badoQZNY"
              },
              {
                title: "關島塞班1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/5Qd7oAMnZ"
              }
            ],
            US: [
              {
                title: "美國 單國套餐",
                price: "NTD 99",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/brmRvRnLK"
              },
              {
                title: "美國 單國套餐",
                price: "NTD 190",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/Epz8LlJJy"
              },
              {
                title: "美加墨3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv"
              },
              {
                title: "美加墨3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CA: [
              {
                title: "加拿大 單國套餐",
                price: "NTD 110",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/e8r2n2951"
              },
              {
                title: "加拿大 單國套餐",
                price: "NTD 215",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/vmb1OdJ7Q"
              },
              {
                title: "美加墨3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv"
              },
              {
                title: "美加墨3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MX: [
              {
                title: "墨西哥 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/9KXv9vvlM"
              },
              {
                title: "墨西哥 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/MK28ReQm1"
              },
              {
                title: "美加墨3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv"
              },
              {
                title: "美加墨3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PR: [
              {
                title: "波多黎各 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/PVMZLGYz2"
              },
              {
                title: "波多黎各 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/4aA0zewgK"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            GP: [
              {
                title: "瓜德魯普 單國套餐",
                price: "NTD 189",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/KbEmRmzwa"
              },
              {
                title: "瓜德魯普 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/nVG1Pm4lY"
              }
            ],
            MF: [
              {
                title: "聖馬丁 單國套餐",
                price: "NTD 219",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/PVMZPaKLZ"
              },
              {
                title: "聖馬丁 單國套餐",
                price: "NTD 339",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/vmb1OLKO2"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AG: [
              {
                title: "安地卡及巴布達 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/nVG1PVKXe"
              },
              {
                title: "安地卡及巴布達 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/nVG1PmbYb"
              }
            ],
            AW: [
              {
                title: "阿魯巴 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/brmRvrv4r"
              },
              {
                title: "阿魯巴 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/6bZXmdJB7"
              }
            ],
            KY: [
              {
                title: "開曼群島 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/wG5mnG6O5"
              },
              {
                title: "開曼群島 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/0opLBXKOA"
              }
            ],
            CW: [
              {
                title: "庫拉索島 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/QVladVGyo"
              },
              {
                title: "庫拉索島 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/796Dm3NkN"
              }
            ],
            GD: [
              {
                title: "格瑞那達 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/Nlb8Rl8Gv"
              },
              {
                title: "格瑞那達 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/llLXPmD4O"
              }
            ],
            HT: [
              {
                title: "海地 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/829am2oln"
              },
              {
                title: "海地 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/pVnA1X4lQ"
              }
            ],
            JM: [
              {
                title: "牙買加 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/pVnA1VB4w"
              },
              {
                title: "牙買加 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/wG5mnXayz"
              }
            ],
            TT: [
              {
                title: "千里達 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/pVnAvl5X4"
              },
              {
                title: "千里達 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/3badoQZK1"
              }
            ],
            TC: [
              {
                title: "特克斯和凱科斯群島 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/nVG1PVBDm"
              },
              {
                title: "特克斯和凱科斯群島 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/2rNd0KnkR"
              }
            ],
            MQ: [
              {
                title: "法屬馬丁尼克 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ZENYQEmJB"
              },
              {
                title: "法屬馬丁尼克 單國套餐",
                price: "NTD 699",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/G4OpLml0R"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AI: [
              {
                title: "安圭拉 單國套餐",
                price: "NTD 489",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/KbEmRb3NL"
              },
              {
                title: "安圭拉 單國套餐",
                price: "NTD 819",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/ZENYQP4y1"
              }
            ],
            VG: [
              {
                title: "英屬維京群島 單國套餐",
                price: "NTD 489",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/6bZXmb0m8"
              },
              {
                title: "英屬維京群島 單國套餐",
                price: "NTD 819",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/5Qd7oA1vl"
              }
            ],
            VC: [
              {
                title: "聖文森特及格林納丁斯 單國套餐",
                price: "NTD 489",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/AAYRLA573"
              },
              {
                title: "聖文森特及格林納丁斯 單國套餐",
                price: "NTD 819",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/nVG1Pmgpe"
              }
            ],
            AR: [
              {
                title: "阿根廷 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/Epz8L8dgL"
              },
              {
                title: "阿根廷 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/DKLB0MXZV"
              },
              {
                title: "阿根廷巴西秘魯3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/6bZXmdPZm"
              },
              {
                title: "阿根廷巴西秘魯3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/1aKmArk37"
              }
            ],
            BR: [
              {
                title: "巴西 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/YmKYe301n"
              },
              {
                title: "巴西 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/XvpYJa4MK"
              },
              {
                title: "阿根廷巴西秘魯3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/6bZXmdPZm"
              },
              {
                title: "阿根廷巴西秘魯3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/1aKmArk37"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PE: [
              {
                title: "秘魯 單國套餐",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/4aA063ZBk"
              },
              {
                title: "秘魯 單國套餐",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/QVlaevrpR"
              },
              {
                title: "阿根廷巴西秘魯3國500MB",
                price: "NTD 129",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/6bZXmdPZm"
              },
              {
                title: "阿根廷巴西秘魯3國1GB",
                price: "NTD 249",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/1aKmArk37"
              }
            ],
            CO: [
              {
                title: "哥倫比亞 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/796Dm9O3V"
              },
              {
                title: "哥倫比亞 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/QVladv3eo"
              }
            ],
            UY: [
              {
                title: "烏拉圭 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/LL3a6LELv"
              },
              {
                title: "烏拉圭 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/nVG1PmDDm"
              }
            ],
            VE: [
              {
                title: "委內瑞拉 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/6bZXmXdm7"
              },
              {
                title: "委內瑞拉 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/ZENYQP5VB"
              }
            ],
            GY: [
              {
                title: "圭亞那 單國套餐",
                price: "NTD 159",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/okODLkaDe"
              },
              {
                title: "圭亞那 單國套餐",
                price: "NTD 309",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/9KXv9JQEr"
              }
            ],
            PA: [
              {
                title: "巴拿馬 單國套餐",
                price: "NTD 219",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/gmPz4DpMo"
              },
              {
                title: "巴拿馬 單國套餐",
                price: "NTD 399",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/wG5mnXeO3"
              }
            ],
            CL: [
              {
                title: "智利 單國套餐",
                price: "NTD 249",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/RLDm4L91P"
              },
              {
                title: "智利 單國套餐",
                price: "NTD 459",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/829am6m8P"
              },
              {
                title: "全球85國10GB",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BO: [
              {
                title: "玻利維亞 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/YmKYAmmD4"
              },
              {
                title: "玻利維亞 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/brmRvaJ6m"
              }
            ],
            CR: [
              {
                title: "哥斯大黎加 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/0opLB05wA"
              },
              {
                title: "哥斯大黎加 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/ynl8wb5vg"
              }
            ],
            SR: [
              {
                title: "蘇利南 單國套餐",
                price: "NTD 339",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/KbEmRb9pd"
              },
              {
                title: "蘇利南 單國套餐",
                price: "NTD 579",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/PVMZLGlOR"
              }
            ],
            EC: [
              {
                title: "厄瓜多爾 單國套餐",
                price: "NTD 369",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/aNXYkNl3v"
              },
              {
                title: "厄瓜多爾 單國套餐",
                price: "NTD 609",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/wG5mnXzMV"
              }
            ],
            DO: [
              {
                title: "多明尼加共和國 單國套餐",
                price: "NTD 459",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ZENYQE5L4"
              },
              {
                title: "多明尼加共和國 單國套餐",
                price: "NTD 789",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/wG5m4XBbg"
              }
            ],
            GT: [
              {
                title: "瓜地馬拉 單國套餐",
                price: "NTD 459",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/3badobL8Q"
              },
              {
                title: "瓜地馬拉 單國套餐",
                price: "NTD 789",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/796Dm3N2m"
              }
            ],
            NI: [
              {
                title: "尼加拉瓜 單國套餐",
                price: "NTD 459",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/ZENYDM1B4"
              },
              {
                title: "尼加拉瓜 單國套餐",
                price: "NTD 789",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/RLDm4bpvr"
              }
            ],
            SV: [
              {
                title: "薩爾瓦多 單國套餐",
                price: "NTD 459",
                labels: ["1天", "500MB"],
                url: "https://dl.gl/zeD9YekLn"
              },
              {
                title: "薩爾瓦多 單國套餐",
                price: "NTD 789",
                labels: ["1天", "1GB"],
                url: "https://dl.gl/1aKm1G9VO"
              }
            ]
          },
          en: {
            GLOBAL: [
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TW: [
              {
                title: "Taiwan Unlimited Package",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/MKkNon7ep",
                code: "Taiwan"
              },
               {
                title: "Data Package Taiwan 14 days/ Unlimited",
                price: "NTD 300",
                labels: ["14 days", "Unlimited"],
                url: "https://dl.gl/ARX8NLD17",
                code: "Taiwan"
              },
              {
                title: "Data Package Taiwan Monthly/ Unlimited",
                labels: ["1 month", "Unlimited"],
                code: "Taiwan",
                price: 'NTD 390',
                url: 'https://dl.gl/RLY0550BJ'
              }
            ],
            JP: [
              {
                title: "Japan  package",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/1aKma2Y9O"
              },
              {
                title: "Japan, Korea Unlimited package",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/BpyALBbgk"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            KR: [
              {
                title: "Korea  package",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/LL3a6LmlN"
              },
              {
                title: "Japan, Korea Unlimited package",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/BpyALBbgk"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CN: [
              {
                title: "China package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlb8R8ZdZ"
              },
              {
                title: "China package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a8mXJv"
              },
              {
                title: "China Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlinited"],
                url: "https://dl.gl/aNXYk4XaQ"
              },
              {
                title: "China, Southeast asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "China, Southeast asia 6 countries package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "China, Russia 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8wmB4L"
              },
              {
                title: "China, Russia 1GB package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXYkeXZQ"
              },
              {
                title: "China, Russia Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/Oo5LRvOzL"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            HK: [
              {
                title: "Hong Kong package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQYK72"
              },
              {
                title: "Hong Kong package",
                price: "NTD 139",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/1aKmAaOk6"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MO: [
              {
                title: "Macao package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVG1P1zwL"
              },
              {
                title: "Macao package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7o7DDB"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SG: [
              {
                title: "Singapore package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVlaVBe4Q"
              },
              {
                title: "Singapore Unlimited package",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnA1Vp8l"
              },
              {
                title: "China, Southeast asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "SG MY TH VN Unlimited package",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4w6YG1KD"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MY: [
              {
                title: "Malaysia package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRo6O6Xwy"
              },
              {
                title: "Malaysia Unlimited package",
                price: "NTD 99",
                labels: ["1 day ", "Unlimited"],
                url: "https://dl.gl/LL3a6LBvv"
              },
              {
                title: "China, Southeast asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "SG MY TH VN Unlimited package",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4w6YG1KD"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TH: [
              {
                title: "Thailand package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYRzJkN7"
              },
              {
                title: "Thailand Unlimited package",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/vmb1OmzMl"
              },
              {
                title: "China, Southeast asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "SG MY TH VN Unlimited package",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4w6YG1KD"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            VN: [
              {
                title: "Vietnam package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDm4Lr6J"
              },
              {
                title: "Vietnam Unlimited package",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/ZENYQYgl9"
              },
              {
                title: "China, Southeast Asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "SG MY TH VN Unlimited package",
                price: "NTD 99",
                labels: ["1 day", "Unlimited data"],
                url: "https://dl.gl/J4w6YG1KD"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            ID: [
              {
                title: "Indonesia package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlb8R8Eml"
              },
              {
                title: "Indonesia package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28R4l0z"
              },
              {
                title: "China, Southeast Asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "China, Southeast Asia 6 countries package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PH: [
              {
                title: "Philippines package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/VY8m4mvka"
              },
              {
                title: "Philippines package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynl8w8AoL"
              },
              {
                title: "China, Southeast Asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "China, Southeast Asia 6 countries package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            KH: [
              {
                title: "Cambodia package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5mPDRQz"
              },
              {
                title: "Cambodia package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZX1BaBy"
              },
              {
                title: "China, Southeast Asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "China, Southeast Asia 6 countries package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LA: [
              {
                title: "Laos package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPXaYB"
              },
              {
                title: "Laos package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RK9rl"
              },
              {
                title: "China, Southeast Asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "China, Southeast Asia 6 countries package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MM: [
              {
                title: "Myanmar package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvR0Pp"
              },
              {
                title: "Myanmar package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVladVRJo"
              },
              {
                title: "China, Southeast Asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "China, Southeast Asia 6 countries package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IN: [
              {
                title: "India package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796DmD7KD"
              },
              {
                title: "India package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RKY51"
              },
              {
                title: "China, Southeast Asia 10 countries package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11"
              },
              {
                title: "China, Southeast Asia 6 countries package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IL: [
              {
                title: "Israel package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KXv9vEZ1"
              },
              {
                title: "Israel package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmbGJy"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BD: [
              {
                title: "Bangladesh package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgMbMlnY"
              },
              {
                title: "Bangladesh package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0rrKO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LK: [
              {
                title: "Sri Lanka package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRo6O6pGZ"
              },
              {
                title: "Sri Lanka package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDm4Lkwn"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            NP: [
              {
                title: "Nepal package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNd0d5X4"
              },
              {
                title: "Nepal package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llLXgYkEa"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            JO: [
              {
                title: "Jordan package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladazp0"
              },
              {
                title: "Jordan package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6Y4nMG"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MN: [
              {
                title: "Mongolia package",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Epz8L8BQJ"
              },
              {
                title: "Mongolia package",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRo6OR6BY"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            QA: [
              {
                title: "Qatar package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Oo5LRLMM8"
              },
              {
                title: "Qatar package",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zaZ5y"
              }
            ],
            SA: [
              {
                title: "Saudi Arabia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aA0z0MJK"
              },
              {
                title: "Saudi Arabia package",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a6LpM5"
              }
            ],
            BN: [
              {
                title: "Brunei package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aA0z04Yz"
              },
              {
                title: "Brunei package",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVladV2BR"
              }
            ],
            MV: [
              {
                title: "Maldives package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4w6Y6aBp"
              },
              {
                title: "Maldives package",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVladVG00"
              }
            ],
            BH: [
              {
                title: "Bahrain package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/BpyALAp5K"
              },
              {
                title: "Bahrain package",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oQgYl"
              }
            ],
            PK: [
              {
                title: "Pakistan package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OpLpmbZ"
              },
              {
                title: "Pakistan package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kLgMbL8p3"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            KZ: [
              {
                title: "Kazakhstan package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5Qd7oQRYa"
              },
              {
                title: "Kazakhstan package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zarrZ"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AE: [
              {
                title: "UAE package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnA1Vklw"
              },
              {
                title: "UAE package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6Y4GKa"
              }
            ],
            AZ: [
              {
                title: "Azerbaijan package",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNd0apre"
              },
              {
                title: "Azerbaijan package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmbbNy"
              }
            ],
            AM: [
              {
                title: "Armenia package",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVG1PV28J"
              },
              {
                title: "Armenia package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Nlb8R47ze"
              }
            ],
            GE: [
              {
                title: "Georgia package",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeD9EeAG2"
              },
              {
                title: "Georgia package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb1OmLwK"
              }
            ],
            OM: [
              {
                title: "Oman package",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8wno6l"
              },
              {
                title: "Oman package",
                price: "NTD 339",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Epz8La50v"
              }
            ],
            KW: [
              {
                title: "Kuwait package",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPlMok"
              },
              {
                title: "Kuwait package",
                price: "NTD 339",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1P8GBJ"
              }
            ],
            TJ: [
              {
                title: "Tajikistan package",
                price: "NTD 279",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXYkNpPk"
              },
              {
                title: "Tajikistan package",
                price: "NTD 459",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0OmQO"
              }
            ],
            AT: [
              {
                title: "Austria package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0opLBL3bp"
              },
              {
                title: "Austria package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMZLvwKB"
              },
              {
                title: "Austria Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4w6Yv0LD"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BG: [
              {
                title: "Bulgaria package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OpLpozR"
              },
              {
                title: "Bulgaria package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "ttps://dl.gl/nVG1P85B4"
              },
              {
                title: "Bulgaria Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/9KXv9oEB1"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CH: [
              {
                title: "Switzerland package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnA1AQ1l"
              },
              {
                title: "Switzerland package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDm49DAm"
              },
              {
                title: "Switzerland Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/YmKYAB8lB"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CZ: [
              {
                title: "Czech Republic package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMZLZkmO"
              },
              {
                title: "Czech Republic package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zd9l8"
              },
              {
                title: "Czech Republic Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/kLgMbR9zQ"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            DE: [
              {
                title: "Germany package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/vmb1O18gY"
              },
              {
                title: "Germany package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a6KN0M"
              },
              {
                title: "Germany Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/RLDm49KRn"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            DK: [
              {
                title: "Denmark package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/829ama3eE"
              },
              {
                title: "Denmark package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7o0yOG"
              },
              {
                title: "Denmark Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/1aKmAGVwr"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            EE: [
              {
                title: "Estonia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/rRw1APLK5"
              },
              {
                title: "Estonia package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llLXPm2Gr"
              },
              {
                title: "Estonia Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/KbEmRmKyp"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            ES: [
              {
                title: "Spain package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPzwzKNz"
              },
              {
                title: "Spain package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPzwN69l"
              },
              {
                title: "Spain Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/KbEmRv81Y"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            FI: [
              {
                title: "Finland package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/829amaywO"
              },
              {
                title: "Finland package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmRvyBXm"
              },
              {
                title: "Finland Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/5Qd7oZkAa"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            FR: [
              {
                title: "France package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvRNYK"
              },
              {
                title: "France package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0O2JJ"
              },
              {
                title: "France Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/llLXV0KmO"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            GB: [
              {
                title: "United Kingdom package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeD9E9N7O"
              },
              {
                title: "United Kingdom package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0O8A1"
              },
              {
                title: "United Kingdom Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/3badobXA0"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            HR: [
              {
                title: "Croatia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8w8Dy6"
              },
              {
                title: "Croatia package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6982yp"
              },
              {
                title: "Croatia Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/QVla3Z2MX"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IE: [
              {
                title: "Ireland package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/vmb1O1zY2"
              },
              {
                title: "Ireland package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/YmKYABZpV"
              },
              {
                title: "Ireland Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/e8r2n1oDZ"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IS: [
              {
                title: "Iceland package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladZRNQ"
              },
              {
                title: "Iceland package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/pVnA1PrBO"
              },
              {
                title: "Iceland Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/wG5mnAZ6V"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IT: [
              {
                title: "Italy package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKmAmk2g"
              },
              {
                title: "Italy package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8r2n1N19"
              },
              {
                title: "Italy Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/gmPzwDgvD"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LV: [
              {
                title: "Latvia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3a6aO4m"
              },
              {
                title: "Latvia package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynl8wbR3l"
              },
              {
                title: "Latvia Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/PVMZLGRzL"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MT: [
              {
                title: "Malta package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/BpyAlm9G6"
              },
              {
                title: "Malta package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Nlb8R4mbb"
              },
              {
                title: "Malta Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/kLgMbR433"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            NO: [
              {
                title: "Norway package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8w84LB"
              },
              {
                title: "Norway package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/rRw1KRovY"
              },
              {
                title: "Norway Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/KbEmRvgve"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PL: [
              {
                title: "Poland package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5Qd7o75Ma"
              },
              {
                title: "Poland package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmdblp"
              },
              {
                title: "Poland Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/e8r2n1arw"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PT: [
              {
                title: "Portugal package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2n2BBb"
              },
              {
                title: "Portugal package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7o0DV7"
              },
              {
                title: "Portugal Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnA1P8bQ"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            RO: [
              {
                title: "Romania package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5Qd7p2bz5"
              },
              {
                title: "Romania package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28ReK0g"
              },
              {
                title: "Romania Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/kLgMbRZ07"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            RU: [
              {
                title: "Russia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmXvAD"
              },
              {
                title: "Russia package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6YGK6Z"
              },
              {
                title: "Russia Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/brmRvy3Yr"
              },
              {
                title: "China, Russia 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8wmB4L"
              },
              {
                title: "China, Russia 1GB package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXYkeXZQ"
              },
              {
                title: "China, Russia Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/Oo5LRvOzL"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SE: [
              {
                title: "Sweden package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXm79GQ"
              },
              {
                title: "Sweden package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3badonp4p"
              },
              {
                title: "Sweden Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/aNXYnGplv"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SI: [
              {
                title: "Slovenia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KXv9v1w8"
              },
              {
                title: "Slovenia package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRMzKLX"
              },
              {
                title: "Slovenia Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/wG5mnAZAN"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SK: [
              {
                title: "Slovakia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmX89X"
              },
              {
                title: "Slovakia package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnArBG"
              },
              {
                title: "Slovakia Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/RLDm2BYg4"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TR: [
              {
                title: "Turkey package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKmAmvwv"
              },
              {
                title: "Turkey package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5LR9RdL"
              },
              {
                title: "Turkey Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/llLXPRkPE"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            UA: [
              {
                title: "Ukraine package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvRdQ8"
              },
              {
                title: "Ukraine package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRL02yX"
              },
              {
                title: "Ukraine Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/aNXYnkZw1"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LI: [
              {
                title: "Liechtenstein package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladaNZl"
              },
              {
                title: "Liechtenstein package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmAGO9v"
              },
              {
                title: "Liechtenstein Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/XvpYJokmO"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            VA: [
              {
                title: "Vatican package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPzwz5Dz"
              },
              {
                title: "Vatican package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3badono70"
              },
              {
                title: "Vatican Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/3badonPym"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MC: [
              {
                title: "Monaco package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPX7Pr"
              },
              {
                title: "Monaco package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXYk4Dov"
              },
              {
                title: "Monaco Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/vmb1OLavG"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AX: [
              {
                title: "Åland Islands package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXYkYmrQ"
              },
              {
                title: "Åland Islands package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8r2n1k59"
              },
              {
                title: "Åland Islands Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/4aA0RQZ58"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            SM: [
              {
                title: "San Marino package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvR298"
              },
              {
                title: "San Marino package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BpyALmXJm"
              },
              {
                title: "San Marino Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/LL3aO9dZg"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            NL: [
              {
                title: "Netherlands package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/m1zLMLOp9"
              },
              {
                title: "Netherlands package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a6KBym"
              },
              {
                title: "Netherlands Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/3badoneG0"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BE: [
              {
                title: "Belgium package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKmAmA0Z"
              },
              {
                title: "Belgium package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynl8wG2a6"
              },
              {
                title: "Belgium Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/brmRvy9rr"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LU: [
              {
                title: "Luxembourg package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPXy7o"
              },
              {
                title: "Luxembourg package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/m1zLkYEJ9"
              },
              {
                title: "Luxembourg Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/QVladOgPk"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Europe 35 countries Unlimited package",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CY: [
              {
                title: "Cyprus package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5mnmyrg"
              },
              {
                title: "Cyprus package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zdLEN"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            GR: [
              {
                title: "Greece package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQY8KN"
              },
              {
                title: "Greece package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb1OLm0G"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            HU: [
              {
                title: "Hungary package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgMbMplQ"
              },
              {
                title: "Hungary package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpYJeOVD"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            LT: [
              {
                title: "Lithuania package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Epz8L8nYw"
              },
              {
                title: "Lithuania package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmRvamV0"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            RS: [
              {
                title: "Serbia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYRME8ZK"
              },
              {
                title: "Serbia package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VY8m4P8Ja"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            ME: [
              {
                title: "Montenegro package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYRLREPX"
              },
              {
                title: "Montenegro package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kLgMbY9m1"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            GG: [
              {
                title: "Guernsey package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlb8R8OmO"
              },
              {
                title: "Guernsey package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXYkRPVZ"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            JE: [
              {
                title: "Jersey package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/rRw1A1A4L"
              },
              {
                title: "Jersey package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1PmwrY"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            IM: [
              {
                title: "Isle of man package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQY8Jv"
              },
              {
                title: "Isle of man package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/829am699Y"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BA: [
              {
                title: "Bosnia and Herzegovina package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKmAebLv"
              },
              {
                title: "Bosnia and Herzegovina package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3badoQzKp"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            GI: [
              {
                title: "Gibraltar package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEMap"
              },
              {
                title: "Gibraltar package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/829am67K2"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            AL: [
              {
                title: "Albania package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XvpYJvZkQ"
              },
              {
                title: "Albania package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Epz8Ll28g"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MK: [
              {
                title: "Macedonia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3a6Llb7"
              },
              {
                title: "Macedonia package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Epz8LlPgy"
              },
              {
                title: "Europe 48 countries 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Europe 48 countries 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e"
              }
            ],
            EG: [
              {
                title: "Egypt package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badodnzQ"
              },
              {
                title: "Egypt package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llLXP6ayo"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MA: [
              {
                title: "Morocco package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgMbML81"
              },
              {
                title: "Morocco package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmArwGO"
              }
            ],
            KE: [
              {
                title: "Kenya package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladVBJ0"
              },
              {
                title: "Kenya package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5LRvDN8"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            EH: [
              {
                title: "Western Sahara package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/okODLkVNJ"
              },
              {
                title: "Western Sahara package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/G4OpLmkRM"
              }
            ],
            GH: [
              {
                title: "Ghana package",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4Op8NR6M"
              },
              {
                title: "Ghana package",
                price: "NTD 369",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BpyALdk71"
              }
            ],
            ZA: [
              {
                title: "South Africa package",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796Dm9l5D"
              },
              {
                title: "South Africa package",
                price: "NTD 369",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8r2nMJ8v"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MG: [
              {
                title: "Madagascar package",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badobwop"
              },
              {
                title: "Madagascar package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnXVVz"
              }
            ],
            DZ: [
              {
                title: "Algeria package",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRo6ORVX1"
              },
              {
                title: "Algeria package",
                price: "NTD 399",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRo6ONAeV"
              }
            ],
            ZM: [
              {
                title: "Zambia package",
                price: "NTD 249",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvr4Qw"
              },
              {
                title: "Zambia package",
                price: "NTD 429",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmdBLm"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MU: [
              {
                title: "Mauritius package",
                price: "NTD 309",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OpL4mnZ"
              },
              {
                title: "Mauritius package",
                price: "NTD 549",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a6vgbz"
              }
            ],
            NG: [
              {
                title: "Nigeria package",
                price: "NTD 309",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badobA01"
              },
              {
                title: "Nigeria package",
                price: "NTD 549",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oAOK7"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TN: [
              {
                title: "Tunisia package",
                price: "NTD 309",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OpL4ezZ"
              },
              {
                title: "Tunisia package",
                price: "NTD 549",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6YGEzZ"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            TZ: [
              {
                title: "Tanzania package",
                price: "NTD 309",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeD9EePB2"
              },
              {
                title: "Tanzania package",
                price: "NTD 549",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpYJenOK"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AO: [
              {
                title: "Angola package",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2n8YEk"
              },
              {
                title: "Angola package",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/zeD9E5z43"
              }
            ],
            AU: [
              {
                title: "Australia package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPzwzzKD"
              },
              {
                title: "Australia package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmRva6Vn"
              },
              {
                title: "New Zealand,Australia,Fiji 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ"
              },
              {
                title: "New Zealand,Australia,Fiji 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okODLme9G"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            NZ: [
              {
                title: "New Zealand package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPX55g"
              },
              {
                title: "New Zealand package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPzwYZ8w"
              },
              {
                title: "New Zealand,Australia,Fiji 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ"
              },
              {
                title: "New Zealand,Australia,Fiji 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okODLme9G"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            FJ: [
              {
                title: "Fiji package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KXv9vKQ4"
              },
              {
                title: "Fiji package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMZP7Va9"
              },
              {
                title: "New Zealand,Australia,Fiji 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ"
              },
              {
                title: "New Zealand,Australia,Fiji 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okODLme9G"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            GU: [
              {
                title: "Guam package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKYAYaNP"
              },
              {
                title: "Guam package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okODLmemw"
              },
              {
                title: "Guam, Saipan 500MB package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoQZNY"
              },
              {
                title: "Guam, Saipan 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oAMnZ"
              }
            ],
            MP: [
              {
                title: "Saipan package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvrX9w"
              },
              {
                title: "Saipan package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpYJe9LP"
              },
              {
                title: "Guam, Saipan 500MB package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoQZNY"
              },
              {
                title: "Guam, Saipan 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oAMnZ"
              }
            ],
            US: [
              {
                title: "United States package",
                price: "NTD 99",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvRnLK"
              },
              {
                title: "United States package",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Epz8LlJJy"
              },
              {
                title: "United States, Canada, Mexico 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv"
              },
              {
                title: "United States, Canada, Mexico 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            CA: [
              {
                title: "Canada package",
                price: "NTD 110",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2n2951"
              },
              {
                title: "Canada package",
                price: "NTD 215",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb1OdJ7Q"
              },
              {
                title: "United States, Canada, Mexico 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv"
              },
              {
                title: "United States, Canada, Mexico 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            MX: [
              {
                title: "Mexico package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KXv9vvlM"
              },
              {
                title: "Mexico package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28ReQm1"
              },
              {
                title: "United States, Canada, Mexico 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv"
              },
              {
                title: "United States, Canada, Mexico 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PR: [
              {
                title: "Puerto Rico package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMZLGYz2"
              },
              {
                title: "Puerto Rico package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zewgK"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            GP: [
              {
                title: "Guadeloupe package",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbEmRmzwa"
              },
              {
                title: "Guadeloupe package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1Pm4lY"
              }
            ],
            MF: [
              {
                title: "Saint Martin package",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMZPaKLZ"
              },
              {
                title: "Saint Martin package",
                price: "NTD 339",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb1OLKO2"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AG: [
              {
                title: "Antigua and Barbuda package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVG1PVKXe"
              },
              {
                title: "Antigua and Barbuda package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1PmbYb"
              }
            ],
            AW: [
              {
                title: "Aruba package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvrv4r"
              },
              {
                title: "Aruba package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmdJB7"
              }
            ],
            KY: [
              {
                title: "Cayman Islands package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5mnG6O5"
              },
              {
                title: "Cayman Islands package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/0opLBXKOA"
              }
            ],
            CW: [
              {
                title: "Curacao package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladVGyo"
              },
              {
                title: "Curacao package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/796Dm3NkN"
              }
            ],
            GD: [
              {
                title: "Grenada package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlb8Rl8Gv"
              },
              {
                title: "Grenada package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llLXPmD4O"
              }
            ],
            HT: [
              {
                title: "Haiti package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/829am2oln"
              },
              {
                title: "Haiti package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/pVnA1X4lQ"
              }
            ],
            JM: [
              {
                title: "Jamaica package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnA1VB4w"
              },
              {
                title: "Jamaica package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnXayz"
              }
            ],
            TT: [
              {
                title: "Trinidad and Tobago package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnAvl5X4"
              },
              {
                title: "Trinidad and Tobago package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3badoQZK1"
              }
            ],
            TC: [
              {
                title: "Turks and Caicos Islands package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVG1PVBDm"
              },
              {
                title: "Turks and Caicos Islands package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0KnkR"
              }
            ],
            MQ: [
              {
                title: "Martinique package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQEmJB"
              },
              {
                title: "Martinique package",
                price: "NTD 699",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/G4OpLml0R"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            AI: [
              {
                title: "Anguilla package",
                price: "NTD 489",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbEmRb3NL"
              },
              {
                title: "Anguilla package",
                price: "NTD 819",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENYQP4y1"
              }
            ],
            VG: [
              {
                title: "British Virgin Islands package",
                price: "NTD 489",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmb0m8"
              },
              {
                title: "British Virgin Islands package",
                price: "NTD 819",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oA1vl"
              }
            ],
            VC: [
              {
                title: "Saint Vincent and the Grenadines package",
                price: "NTD 489",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYRLA573"
              },
              {
                title: "Saint Vincent and the Grenadines package",
                price: "NTD 819",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1Pmgpe"
              }
            ],
            AR: [
              {
                title: "Argentina package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Epz8L8dgL"
              },
              {
                title: "Argentina package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLB0MXZV"
              },
              {
                title: "Argentina, Brazil, Peru 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmdPZm"
              },
              {
                title: "Argentina, Brazil, Peru 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmArk37"
              }
            ],
            BR: [
              {
                title: "Brazil package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKYe301n"
              },
              {
                title: "Brazil package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpYJa4MK"
              },
              {
                title: "Argentina, Brazil, Peru 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmdPZm"
              },
              {
                title: "Argentina, Brazil, Peru 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmArk37"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            PE: [
              {
                title: "Peru  package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aA063ZBk"
              },
              {
                title: "Peru  package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlaevrpR"
              },
              {
                title: "Argentina, Brazil, Peru 500MB package",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmdPZm"
              },
              {
                title: "Argentina, Brazil, Peru 1GB package",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmArk37"
              }
            ],
            CO: [
              {
                title: "Colombia package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796Dm9O3V"
              },
              {
                title: "Colombia package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVladv3eo"
              }
            ],
            UY: [
              {
                title: "Uruguay package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3a6LELv"
              },
              {
                title: "Uruguay package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1PmDDm"
              }
            ],
            VE: [
              {
                title: "Venezuela package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmXdm7"
              },
              {
                title: "Venezuela package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENYQP5VB"
              }
            ],
            GY: [
              {
                title: "Guyana package",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/okODLkaDe"
              },
              {
                title: "Guyana package",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/9KXv9JQEr"
              }
            ],
            PA: [
              {
                title: "Panama package",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPz4DpMo"
              },
              {
                title: "Panama package",
                price: "NTD 399",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnXeO3"
              }
            ],
            CL: [
              {
                title: "Chile package",
                price: "NTD 249",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDm4L91P"
              },
              {
                title: "Chile package",
                price: "NTD 459",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/829am6m8P"
              },
              {
                title: "Global 85 countries 10GB package",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V"
              }
            ],
            BO: [
              {
                title: "Bolivia package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKYAmmD4"
              },
              {
                title: "Bolivia package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmRvaJ6m"
              }
            ],
            CR: [
              {
                title: "Costa Rica package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0opLB05wA"
              },
              {
                title: "Costa Rica package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynl8wb5vg"
              }
            ],
            SR: [
              {
                title: "Suriname package",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbEmRb9pd"
              },
              {
                title: "Suriname package",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMZLGlOR"
              }
            ],
            EC: [
              {
                title: "Ecuador package",
                price: "NTD 369",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXYkNl3v"
              },
              {
                title: "Ecuador package",
                price: "NTD 609",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnXzMV"
              }
            ],
            DO: [
              {
                title: "The Dominican Republic package",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQE5L4"
              },
              {
                title: "The Dominican Republic package",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5m4XBbg"
              }
            ],
            GT: [
              {
                title: "Guatemala package",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badobL8Q"
              },
              {
                title: "Guatemala package",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/796Dm3N2m"
              }
            ],
            NI: [
              {
                title: "Nicaragua package",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYDM1B4"
              },
              {
                title: "Nicaragua package",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDm4bpvr"
              }
            ],
            SV: [
              {
                title: "El Salvador package",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeD9YekLn"
              },
              {
                title: "El Salvador package",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKm1G9VO"
              }
            ]
          },
          ja: {
            GLOBAL: [
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            JP: [
              {
                title: "日本 Unlimited プラン",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/1aKma2Y9O",
                code: "Japan"
              },
              {
                title: "Japan, Korea Unlimited プラン",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/BpyALBbgk",
                code: "Japan, Korea"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            KR: [
              {
                title: "韓国 Unlimited プラン",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/LL3a6LmlN",
                code: "Korea"
              },
              {
                title: "Japan, Korea Unlimited プラン",
                price: "NTD 69",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/BpyALBbgk",
                code: "Japan, Korea"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            CN: [
              {
                title: "中国 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlb8R8ZdZ",
                code: "China"
              },
              {
                title: "中国 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a8mXJv",
                code: "China"
              },
              {
                title: "中国 Unlinited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlinited"],
                url: "https://dl.gl/aNXYk4XaQ",
                code: "China"
              },
              {
                title: "China, Southeast asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast asia 10 countries"
              },
              {
                title: "China, Southeast asia 6 countries 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl",
                code: "China, Southeast asia 6 countries"
              },
              {
                title: "China, Russia 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8wmB4L",
                code: "China, Russia"
              },
              {
                title: "China, Russia 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXYkeXZQ",
                code: "China, Russia"
              },
              {
                title: "China, Russia Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/Oo5LRvOzL",
                code: "China, Russia"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            HK: [
              {
                title: "香港 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQYK72",
                code: "Hong Kong"
              },
              {
                title: "香港 Unlimited プラン",
                price: "NTD 139",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/1aKmAaOk6",
                code: "Hong Kong"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MO: [
              {
                title: "マカオ 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVG1P1zwL",
                code: "Macao"
              },
              {
                title: "マカオ 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7o7DDB",
                code: "Macao"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            SG: [
              {
                title: "シンガポール 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVlaVBe4Q",
                code: "Singapore"
              },
              {
                title: "シンガポール Unlimited プラン",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnA1Vp8l",
                code: "Singapore"
              },
              {
                title: "China, Southeast asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast asia 10 countries"
              },
              {
                title: "SG MY TH VN Unlimited プラン",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4w6YG1KD",
                code: "SG MY TH VN"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MY: [
              {
                title: "マレーシア 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRo6O6Xwy",
                code: "Malaysia"
              },
              {
                title: "マレーシア Unlimited プラン",
                price: "NTD 99",
                labels: ["1 day ", "Unlimited"],
                url: "https://dl.gl/LL3a6LBvv",
                code: "Malaysia"
              },
              {
                title: "China, Southeast asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast asia 10 countries"
              },
              {
                title: "SG MY TH VN Unlimited プラン",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4w6YG1KD",
                code: "SG MY TH VN"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            TH: [
              {
                title: "タイ 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYRzJkN7",
                code: "Thailand"
              },
              {
                title: "タイ Unlimited プラン",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/vmb1OmzMl",
                code: "Thailand"
              },
              {
                title: "China, Southeast asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast asia 10 countries"
              },
              {
                title: "SG MY TH VN Unlimited プラン",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4w6YG1KD",
                code: "SG MY TH VN"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            VN: [
              {
                title: "ベトナム 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDm4Lr6J",
                code: "Vietnam"
              },
              {
                title: "ベトナム Unlimited プラン",
                price: "NTD 99",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/ZENYQYgl9",
                code: "Vietnam"
              },
              {
                title: "China, Southeast Asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast Asia 10 countries"
              },
              {
                title: "SG MY TH VN Unlimited data プラン",
                price: "NTD 99",
                labels: ["1 day", "Unlimited data"],
                url: "https://dl.gl/J4w6YG1KD",
                code: "SG MY TH VN"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            ID: [
              {
                title: "インドネシア 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlb8R8Eml",
                code: "Indonesia"
              },
              {
                title: "インドネシア 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28R4l0z",
                code: "Indonesia"
              },
              {
                title: "China, Southeast Asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast Asia 10 countries"
              },
              {
                title: "China, Southeast Asia 6 countries 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl",
                code: "China, Southeast Asia 6 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            PH: [
              {
                title: "フィリピン 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/VY8m4mvka",
                code: "Philippines"
              },
              {
                title: "フィリピン 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynl8w8AoL",
                code: "Philippines"
              },
              {
                title: "China, Southeast Asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast Asia 10 countries"
              },
              {
                title: "China, Southeast Asia 6 countries 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl",
                code: "China, Southeast Asia 6 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            KH: [
              {
                title: "カンボジア 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5mPDRQz",
                code: "Cambodia"
              },
              {
                title: "カンボジア 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZX1BaBy",
                code: "Cambodia"
              },
              {
                title: "China, Southeast Asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast Asia 10 countries"
              },
              {
                title: "China, Southeast Asia 6 countries 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl",
                code: "China, Southeast Asia 6 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            LA: [
              {
                title: "ラオス 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPXaYB",
                code: "Laos"
              },
              {
                title: "ラオス 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RK9rl",
                code: "Laos"
              },
              {
                title: "China, Southeast Asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast Asia 10 countries"
              },
              {
                title: "China, Southeast Asia 6 countries 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl",
                code: "China, Southeast Asia 6 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MM: [
              {
                title: "ミャンマー 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvR0Pp",
                code: "Myanmar"
              },
              {
                title: "ミャンマー 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVladVRJo",
                code: "Myanmar"
              },
              {
                title: "China, Southeast Asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast Asia 10 countries"
              },
              {
                title: "China, Southeast Asia 6 countries 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl",
                code: "China, Southeast Asia 6 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            IN: [
              {
                title: "インド 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796DmD7KD",
                code: "India"
              },
              {
                title: "インド 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RKY51",
                code: "India"
              },
              {
                title: "China, Southeast Asia 10 countries 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEB11",
                code: "China, Southeast Asia 10 countries"
              },
              {
                title: "China, Southeast Asia 6 countries 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28RerMl",
                code: "China, Southeast Asia 6 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            IL: [
              {
                title: "イスラエル 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KXv9vEZ1",
                code: "Israel"
              },
              {
                title: "イスラエル 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmbGJy",
                code: "Israel"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            BD: [
              {
                title: "バングラデシュ 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgMbMlnY",
                code: "Bangladesh"
              },
              {
                title: "バングラデシュ 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0rrKO",
                code: "Bangladesh"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            LK: [
              {
                title: "スリランカ 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRo6O6pGZ",
                code: "Sri Lanka"
              },
              {
                title: "スリランカ 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDm4Lkwn",
                code: "Sri Lanka"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            NP: [
              {
                title: "ネパール 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNd0d5X4",
                code: "Nepal"
              },
              {
                title: "ネパール 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llLXgYkEa",
                code: "Nepal"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            JO: [
              {
                title: "ヨルダン 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladazp0",
                code: "Jordan"
              },
              {
                title: "ヨルダン 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6Y4nMG",
                code: "Jordan"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MN: [
              {
                title: "モンゴル国 500MB プラン",
                price: "NTD 80",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Epz8L8BQJ",
                code: "Mongolia"
              },
              {
                title: "モンゴル国 1GB プラン",
                price: "NTD 155",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRo6OR6BY",
                code: "Mongolia"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            QA: [
              {
                title: "カタール 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Oo5LRLMM8",
                code: "Qatar"
              },
              {
                title: "カタール 1GB プラン",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zaZ5y",
                code: "Qatar"
              }
            ],
            SA: [
              {
                title: "サウジアラビア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aA0z0MJK",
                code: "Saudi Arabia"
              },
              {
                title: "サウジアラビア 1GB プラン",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a6LpM5",
                code: "Saudi Arabia"
              }
            ],
            BN: [
              {
                title: "ブルネイ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aA0z04Yz",
                code: "Brunei"
              },
              {
                title: "ブルネイ 1GB プラン",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVladV2BR",
                code: "Brunei"
              }
            ],
            MV: [
              {
                title: "モルディブ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4w6Y6aBp",
                code: "Maldives"
              },
              {
                title: "モルディブ 1GB プラン",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVladVG00",
                code: "Maldives"
              }
            ],
            BH: [
              {
                title: "バーレーン 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/BpyALAp5K",
                code: "Bahrain"
              },
              {
                title: "バーレーン 1GB プラン",
                price: "NTD 219",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oQgYl",
                code: "Bahrain"
              }
            ],
            PK: [
              {
                title: "パキスタン 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OpLpmbZ",
                code: "Pakistan"
              },
              {
                title: "パキスタン 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kLgMbL8p3",
                code: "Pakistan"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            KZ: [
              {
                title: "カザフ 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5Qd7oQRYa",
                code: "Kazakhstan"
              },
              {
                title: "カザフ 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zarrZ",
                code: "Kazakhstan"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            AE: [
              {
                title: "アラブ首長国連邦 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnA1Vklw",
                code: "UAE"
              },
              {
                title: "アラブ首長国連邦 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6Y4GKa",
                code: "UAE"
              }
            ],
            AZ: [
              {
                title: "アゼルバイジャン 500MB プラン",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNd0apre",
                code: "Azerbaijan"
              },
              {
                title: "アゼルバイジャン 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmbbNy",
                code: "Azerbaijan"
              }
            ],
            AM: [
              {
                title: "アルメニア 500MB プラン",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVG1PV28J",
                code: "Armenia"
              },
              {
                title: "アルメニア 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Nlb8R47ze",
                code: "Armenia"
              }
            ],
            GE: [
              {
                title: "ジョージア 500MB プラン",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeD9EeAG2",
                code: "Georgia"
              },
              {
                title: "ジョージア 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb1OmLwK",
                code: "Georgia"
              }
            ],
            OM: [
              {
                title: "オマーン 500MB プラン",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8wno6l",
                code: "Oman"
              },
              {
                title: "オマーン 1GB プラン",
                price: "NTD 339",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Epz8La50v",
                code: "Oman"
              }
            ],
            KW: [
              {
                title: "クウェート 500MB プラン",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPlMok",
                code: "Kuwait"
              },
              {
                title: "クウェート 1GB プラン",
                price: "NTD 339",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1P8GBJ",
                code: "Kuwait"
              }
            ],
            TJ: [
              {
                title: "タジキスタン 500MB プラン",
                price: "NTD 279",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXYkNpPk",
                code: "Tajikistan"
              },
              {
                title: "タジキスタン 1GB プラン",
                price: "NTD 459",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0OmQO",
                code: "Tajikistan"
              }
            ],
            AT: [
              {
                title: "オーストリア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0opLBL3bp",
                code: "Austria"
              },
              {
                title: "オーストリア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMZLvwKB",
                code: "Austria"
              },
              {
                title: "オーストリア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4w6Yv0LD",
                code: "Austria"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            BG: [
              {
                title: "ブルガリア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OpLpozR",
                code: "Bulgaria"
              },
              {
                title: "ブルガリア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "ttps://dl.gl/nVG1P85B4",
                code: "Bulgaria"
              },
              {
                title: "ブルガリア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/9KXv9oEB1",
                code: "Bulgaria"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            CH: [
              {
                title: "スイス 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnA1AQ1l",
                code: "Switzerland"
              },
              {
                title: "スイス 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDm49DAm",
                code: "Switzerland"
              },
              {
                title: "スイス Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/YmKYAB8lB",
                code: "Switzerland"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            CZ: [
              {
                title: "チェコ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMZLZkmO",
                code: "Czech Republic"
              },
              {
                title: "チェコ 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zd9l8",
                code: "Czech Republic"
              },
              {
                title: "チェコ Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/kLgMbR9zQ",
                code: "Czech Republic"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            DE: [
              {
                title: "ドイツ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/vmb1O18gY",
                code: "Germany"
              },
              {
                title: "ドイツ 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a6KN0M",
                code: "Germany"
              },
              {
                title: "ドイツ Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/RLDm49KRn",
                code: "Germany"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            DK: [
              {
                title: "デンマーク 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/829ama3eE",
                code: "Denmark"
              },
              {
                title: "デンマーク 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7o0yOG",
                code: "Denmark"
              },
              {
                title: "デンマーク Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/1aKmAGVwr",
                code: "Denmark"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            EE: [
              {
                title: "エストニア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/rRw1APLK5",
                code: "Estonia"
              },
              {
                title: "エストニア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llLXPm2Gr",
                code: "Estonia"
              },
              {
                title: "エストニア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/KbEmRmKyp",
                code: "Estonia"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            ES: [
              {
                title: "スペイン 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPzwzKNz",
                code: "Spain"
              },
              {
                title: "スペイン 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPzwN69l",
                code: "Spain"
              },
              {
                title: "スペイン Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/KbEmRv81Y",
                code: "Spain"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            FI: [
              {
                title: "フィンランド 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/829amaywO",
                code: "Finland"
              },
              {
                title: "フィンランド 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmRvyBXm",
                code: "Finland"
              },
              {
                title: "フィンランド Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/5Qd7oZkAa",
                code: "Finland"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            FR: [
              {
                title: "フランス 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvRNYK",
                code: "France"
              },
              {
                title: "フランス 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0O2JJ",
                code: "France"
              },
              {
                title: "フランス Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/llLXV0KmO",
                code: "France"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            GB: [
              {
                title: "イギリス 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeD9E9N7O",
                code: "United Kingdom"
              },
              {
                title: "イギリス 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0O8A1",
                code: "United Kingdom"
              },
              {
                title: "イギリス Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/3badobXA0",
                code: "United Kingdom"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            HR: [
              {
                title: "クロアチア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8w8Dy6",
                code: "Croatia"
              },
              {
                title: "クロアチア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6982yp",
                code: "Croatia"
              },
              {
                title: "クロアチア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/QVla3Z2MX",
                code: "Croatia"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            IE: [
              {
                title: "アイルランド 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/vmb1O1zY2",
                code: "Ireland"
              },
              {
                title: "アイルランド 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/YmKYABZpV",
                code: "Ireland"
              },
              {
                title: "アイルランド Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/e8r2n1oDZ",
                code: "Ireland"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            IS: [
              {
                title: "アイスランド 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladZRNQ",
                code: "Iceland"
              },
              {
                title: "アイスランド 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/pVnA1PrBO",
                code: "Iceland"
              },
              {
                title: "アイスランド Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/wG5mnAZ6V",
                code: "Iceland"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            IT: [
              {
                title: "イタリア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKmAmk2g",
                code: "Italy"
              },
              {
                title: "イタリア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8r2n1N19",
                code: "Italy"
              },
              {
                title: "イタリア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/gmPzwDgvD",
                code: "Italy"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            LV: [
              {
                title: "ラトビア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3a6aO4m",
                code: "Latvia"
              },
              {
                title: "ラトビア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynl8wbR3l",
                code: "Latvia"
              },
              {
                title: "ラトビア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/PVMZLGRzL",
                code: "Latvia"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MT: [
              {
                title: "マルタ共和国 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/BpyAlm9G6",
                code: "Malta"
              },
              {
                title: "マルタ共和国 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Nlb8R4mbb",
                code: "Malta"
              },
              {
                title: "マルタ共和国 Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/kLgMbR433",
                code: "Malta"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            NO: [
              {
                title: "ノルウェー 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8w84LB",
                code: "Norway"
              },
              {
                title: "ノルウェー 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/rRw1KRovY",
                code: "Norway"
              },
              {
                title: "ノルウェー Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/KbEmRvgve",
                code: "Norway"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            PL: [
              {
                title: "ポーランド 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5Qd7o75Ma",
                code: "Poland"
              },
              {
                title: "ポーランド 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmdblp",
                code: "Poland"
              },
              {
                title: "ポーランド Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/e8r2n1arw",
                code: "Poland"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            PT: [
              {
                title: "ポルトガル 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2n2BBb",
                code: "Portugal"
              },
              {
                title: "ポルトガル 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7o0DV7",
                code: "Portugal"
              },
              {
                title: "ポルトガル Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnA1P8bQ",
                code: "Portugal"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            RO: [
              {
                title: "ルーマニア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5Qd7p2bz5",
                code: "Romania"
              },
              {
                title: "ルーマニア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28ReK0g",
                code: "Romania"
              },
              {
                title: "ルーマニア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/kLgMbRZ07",
                code: "Romania"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            RU: [
              {
                title: "ロシア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmXvAD",
                code: "Russia"
              },
              {
                title: "ロシア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6YGK6Z",
                code: "Russia"
              },
              {
                title: "ロシア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/brmRvy3Yr",
                code: "Russia"
              },
              {
                title: "China, Russia 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynl8wmB4L",
                code: "China, Russia"
              },
              {
                title: "China, Russia 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXYkeXZQ",
                code: "China, Russia"
              },
              {
                title: "China, Russia Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/Oo5LRvOzL",
                code: "China, Russia"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            SE: [
              {
                title: "スウェーデン 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXm79GQ",
                code: "Sweden"
              },
              {
                title: "スウェーデン 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3badonp4p",
                code: "Sweden"
              },
              {
                title: "スウェーデン Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/aNXYnGplv",
                code: "Sweden"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            SI: [
              {
                title: "スロベニア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KXv9v1w8",
                code: "Slovenia"
              },
              {
                title: "スロベニア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRMzKLX",
                code: "Slovenia"
              },
              {
                title: "スロベニア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/wG5mnAZAN",
                code: "Slovenia"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            SK: [
              {
                title: "スロバキア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmX89X",
                code: "Slovakia"
              },
              {
                title: "スロバキア 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnArBG",
                code: "Slovakia"
              },
              {
                title: "スロバキア Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/RLDm2BYg4",
                code: "Slovakia"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            TR: [
              {
                title: "トルコ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKmAmvwv",
                code: "Turkey"
              },
              {
                title: "トルコ 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5LR9RdL",
                code: "Turkey"
              },
              {
                title: "トルコ Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/llLXPRkPE",
                code: "Turkey"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            UA: [
              {
                title: "ウクライナ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvRdQ8",
                code: "Ukraine"
              },
              {
                title: "ウクライナ 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRL02yX",
                code: "Ukraine"
              },
              {
                title: "ウクライナ Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/aNXYnkZw1",
                code: "Ukraine"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            LI: [
              {
                title: "リヒテンシュタイン 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladaNZl",
                code: "Liechtenstein"
              },
              {
                title: "リヒテンシュタイン 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmAGO9v",
                code: "Liechtenstein"
              },
              {
                title: "リヒテンシュタイン Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/XvpYJokmO",
                code: "Liechtenstein"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            VA: [
              {
                title: "バチカン 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPzwz5Dz",
                code: "Vatican"
              },
              {
                title: "バチカン 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3badono70",
                code: "Vatican"
              },
              {
                title: "バチカン Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/3badonPym",
                code: "Vatican"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MC: [
              {
                title: "モナコ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPX7Pr",
                code: "Monaco"
              },
              {
                title: "モナコ 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXYk4Dov",
                code: "Monaco"
              },
              {
                title: "モナコ Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/vmb1OLavG",
                code: "Monaco"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            AX: [
              {
                title: "オーランド諸島 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXYkYmrQ",
                code: "Åland Islands"
              },
              {
                title: "オーランド諸島 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8r2n1k59",
                code: "Åland Islands"
              },
              {
                title: "オーランド諸島 Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/4aA0RQZ58",
                code: "Åland Islands"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            SM: [
              {
                title: "サンマリノ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvR298",
                code: "San Marino"
              },
              {
                title: "サンマリノ 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BpyALmXJm",
                code: "San Marino"
              },
              {
                title: "サンマリノ Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/LL3aO9dZg",
                code: "San Marino"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            NL: [
              {
                title: "オランダ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/m1zLMLOp9",
                code: "Netherlands"
              },
              {
                title: "オランダ 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a6KBym",
                code: "Netherlands"
              },
              {
                title: "オランダ Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/3badoneG0",
                code: "Netherlands"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            BE: [
              {
                title: "ベルギー 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKmAmA0Z",
                code: "Belgium"
              },
              {
                title: "ベルギー 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynl8wG2a6",
                code: "Belgium"
              },
              {
                title: "ベルギー Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/brmRvy9rr",
                code: "Belgium"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            LU: [
              {
                title: "ルクセンブルグ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPXy7o",
                code: "Luxembourg"
              },
              {
                title: "ルクセンブルグ 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/m1zLkYEJ9",
                code: "Luxembourg"
              },
              {
                title: "ルクセンブルグ Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/QVladOgPk",
                code: "Luxembourg"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 35 countries Unlimited プラン",
                price: "NTD 250",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNd0KAAO",
                code: "Europe 35 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            CY: [
              {
                title: "キプロス 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5mnmyrg",
                code: "Cyprus"
              },
              {
                title: "キプロス 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zdLEN",
                code: "Cyprus"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              }
            ],
            GR: [
              {
                title: "ギリシャ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQY8KN",
                code: "Greece"
              },
              {
                title: "ギリシャ 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb1OLm0G",
                code: "Greece"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            HU: [
              {
                title: "ハンガリー 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgMbMplQ",
                code: "Hungary"
              },
              {
                title: "ハンガリー 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpYJeOVD",
                code: "Hungary"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            LT: [
              {
                title: "リトアニア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Epz8L8nYw",
                code: "Lithuania"
              },
              {
                title: "リトアニア 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmRvamV0",
                code: "Lithuania"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            RS: [
              {
                title: "セルビア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYRME8ZK",
                code: "Serbia"
              },
              {
                title: "セルビア 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VY8m4P8Ja",
                code: "Serbia"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            ME: [
              {
                title: "モンテネグロ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYRLREPX",
                code: "Montenegro"
              },
              {
                title: "モンテネグロ 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kLgMbY9m1",
                code: "Montenegro"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              }
            ],
            GG: [
              {
                title: "ガーンジー 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlb8R8OmO",
                code: "Guernsey"
              },
              {
                title: "ガーンジー 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXYkRPVZ",
                code: "Guernsey"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            JE: [
              {
                title: "ジャージー 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/rRw1A1A4L",
                code: "Jersey"
              },
              {
                title: "ジャージー 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1PmwrY",
                code: "Jersey"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            IM: [
              {
                title: "マン島 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQY8Jv",
                code: "Isle of man"
              },
              {
                title: "マン島 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/829am699Y",
                code: "Isle of man"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            BA: [
              {
                title: "ボスニア・ヘルツェゴビナ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKmAebLv",
                code: "Bosnia and Herzegovina"
              },
              {
                title: "ボスニア・ヘルツェゴビナ 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3badoQzKp",
                code: "Bosnia and Herzegovina"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              }
            ],
            GI: [
              {
                title: "ジブラルタル 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoEMap",
                code: "Gibraltar"
              },
              {
                title: "ジブラルタル 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/829am67K2",
                code: "Gibraltar"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              }
            ],
            AL: [
              {
                title: "アルバニア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XvpYJvZkQ",
                code: "Albania"
              },
              {
                title: "アルバニア 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Epz8Ll28g",
                code: "Albania"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MK: [
              {
                title: "マケドニア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3a6Llb7",
                code: "Macedonia"
              },
              {
                title: "マケドニア 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Epz8LlPgy",
                code: "Macedonia"
              },
              {
                title: "Europe 48 countries 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo",
                code: "Europe 48 countries"
              },
              {
                title: "Europe 48 countries 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYRLXz7e",
                code: "Europe 48 countries"
              }
            ],
            EG: [
              {
                title: "エジプト 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badodnzQ",
                code: "Egypt"
              },
              {
                title: "エジプト 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llLXP6ayo",
                code: "Egypt"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MA: [
              {
                title: "モロッコ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgMbML81",
                code: "Morocco"
              },
              {
                title: "モロッコ 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmArwGO",
                code: "Morocco"
              }
            ],
            KE: [
              {
                title: "ケニア 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladVBJ0",
                code: "Kenya"
              },
              {
                title: "ケニア 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5LRvDN8",
                code: "Kenya"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            EH: [
              {
                title: "西サハラ 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/okODLkVNJ",
                code: "Western Sahara"
              },
              {
                title: "西サハラ 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/G4OpLmkRM",
                code: "Western Sahara"
              }
            ],
            GH: [
              {
                title: "ガーナ 500MB プラン",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4Op8NR6M",
                code: "Ghana"
              },
              {
                title: "ガーナ 1GB プラン",
                price: "NTD 369",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/BpyALdk71",
                code: "Ghana"
              }
            ],
            ZA: [
              {
                title: "南アフリカ 500MB プラン",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796Dm9l5D",
                code: "South Africa"
              },
              {
                title: "南アフリカ 1GB プラン",
                price: "NTD 369",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8r2nMJ8v",
                code: "South Africa"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MG: [
              {
                title: "マダガスカル 500MB プラン",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badobwop",
                code: "Madagascar"
              },
              {
                title: "マダガスカル 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnXVVz",
                code: "Madagascar"
              }
            ],
            DZ: [
              {
                title: "アルジェリア 500MB プラン",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRo6ORVX1",
                code: "Algeria"
              },
              {
                title: "アルジェリア 1GB プラン",
                price: "NTD 399",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRo6ONAeV",
                code: "Algeria"
              }
            ],
            ZM: [
              {
                title: "ザンビア 500MB プラン",
                price: "NTD 249",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvr4Qw",
                code: "Zambia"
              },
              {
                title: "ザンビア 1GB プラン",
                price: "NTD 429",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmdBLm",
                code: "Zambia"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MU: [
              {
                title: "モーリシャス 500MB プラン",
                price: "NTD 309",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OpL4mnZ",
                code: "Mauritius"
              },
              {
                title: "モーリシャス 1GB プラン",
                price: "NTD 549",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3a6vgbz",
                code: "Mauritius"
              }
            ],
            NG: [
              {
                title: "ナイジェリア 500MB プラン",
                price: "NTD 309",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badobA01",
                code: "Nigeria"
              },
              {
                title: "ナイジェリア 1GB プラン",
                price: "NTD 549",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oAOK7",
                code: "Nigeria"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            TN: [
              {
                title: "チュニジア 500MB プラン",
                price: "NTD 309",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OpL4ezZ",
                code: "Tunisia"
              },
              {
                title: "チュニジア 1GB プラン",
                price: "NTD 549",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6YGEzZ",
                code: "Tunisia"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            TZ: [
              {
                title: "タンザニア 500MB プラン",
                price: "NTD 309",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeD9EePB2",
                code: "Tanzania"
              },
              {
                title: "タンザニア 1GB プラン",
                price: "NTD 549",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpYJenOK",
                code: "Tanzania"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            AO: [
              {
                title: "アンゴラ 500MB プラン",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2n8YEk",
                code: "Angola"
              },
              {
                title: "アンゴラ 1GB プラン",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/zeD9E5z43",
                code: "Angola"
              }
            ],
            AU: [
              {
                title: "オーストラリア 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPzwzzKD",
                code: "Australia"
              },
              {
                title: "オーストラリア 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmRva6Vn",
                code: "Australia"
              },
              {
                title: "New Zealand,Australia,Fiji 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ",
                code: "New Zealand,Australia,Fiji"
              },
              {
                title: "New Zealand,Australia,Fiji 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okODLme9G",
                code: "New Zealand,Australia,Fiji"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            NZ: [
              {
                title: "ニュージーランド 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llLXPX55g",
                code: "New Zealand"
              },
              {
                title: "ニュージーランド 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPzwYZ8w",
                code: "New Zealand"
              },
              {
                title: "New Zealand,Australia,Fiji 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ",
                code: "New Zealand,Australia,Fiji"
              },
              {
                title: "New Zealand,Australia,Fiji 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okODLme9G",
                code: "New Zealand,Australia,Fiji"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            FJ: [
              {
                title: "フィジー 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KXv9vKQ4",
                code: "Fiji"
              },
              {
                title: "フィジー 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMZP7Va9",
                code: "Fiji"
              },
              {
                title: "New Zealand,Australia,Fiji 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4w6YGrJZ",
                code: "New Zealand,Australia,Fiji"
              },
              {
                title: "New Zealand,Australia,Fiji 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okODLme9G",
                code: "New Zealand,Australia,Fiji"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            GU: [
              {
                title: "グアム 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKYAYaNP",
                code: "Guam"
              },
              {
                title: "グアム 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okODLmemw",
                code: "Guam"
              },
              {
                title: "Guam, Saipan 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoQZNY",
                code: "Guam, Saipan"
              },
              {
                title: "Guam, Saipan 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oAMnZ",
                code: "Guam, Saipan"
              }
            ],
            MP: [
              {
                title: "サイパン 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvrX9w",
                code: "Saipan"
              },
              {
                title: "サイパン 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpYJe9LP",
                code: "Saipan"
              },
              {
                title: "Guam, Saipan 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badoQZNY",
                code: "Guam, Saipan"
              },
              {
                title: "Guam, Saipan 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oAMnZ",
                code: "Guam, Saipan"
              }
            ],
            US: [
              {
                title: "アメリカ 500MB プラン",
                price: "NTD 99",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvRnLK",
                code: "United States"
              },
              {
                title: "アメリカ 1GB プラン",
                price: "NTD 190",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Epz8LlJJy",
                code: "United States"
              },
              {
                title: "United States, Canada, Mexico 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv",
                code: "United States, Canada, Mexico"
              },
              {
                title: "United States, Canada, Mexico 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G",
                code: "United States, Canada, Mexico"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            CA: [
              {
                title: "カナダ 500MB プラン",
                price: "NTD 110",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2n2951",
                code: "Canada"
              },
              {
                title: "カナダ 1GB プラン",
                price: "NTD 215",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb1OdJ7Q",
                code: "Canada"
              },
              {
                title: "United States, Canada, Mexico 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv",
                code: "United States, Canada, Mexico"
              },
              {
                title: "United States, Canada, Mexico 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G",
                code: "United States, Canada, Mexico"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            MX: [
              {
                title: "メキシコ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KXv9vvlM",
                code: "Mexico"
              },
              {
                title: "メキシコ 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK28ReQm1",
                code: "Mexico"
              },
              {
                title: "United States, Canada, Mexico 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aKm3K6Vv",
                code: "United States, Canada, Mexico"
              },
              {
                title: "United States, Canada, Mexico 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4w6p2Q4G",
                code: "United States, Canada, Mexico"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            PR: [
              {
                title: "プエルトリコ 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMZLGYz2",
                code: "Puerto Rico"
              },
              {
                title: "プエルトリコ 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aA0zewgK",
                code: "Puerto Rico"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            GP: [
              {
                title: "グアドループ 500MB プラン",
                price: "NTD 189",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbEmRmzwa",
                code: "Guadeloupe"
              },
              {
                title: "グアドループ 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1Pm4lY",
                code: "Guadeloupe"
              }
            ],
            MF: [
              {
                title: "セントマーティン 500MB プラン",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMZPaKLZ",
                code: "Saint Martin"
              },
              {
                title: "セントマーティン 1GB プラン",
                price: "NTD 339",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb1OLKO2",
                code: "Saint Martin"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            AG: [
              {
                title: "アンティグアバーブーダ 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVG1PVKXe",
                code: "Antigua and Barbuda"
              },
              {
                title: "アンティグアバーブーダ 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1PmbYb",
                code: "Antigua and Barbuda"
              }
            ],
            AW: [
              {
                title: "アルバ 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmRvrv4r",
                code: "Aruba"
              },
              {
                title: "アルバ 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZXmdJB7",
                code: "Aruba"
              }
            ],
            KY: [
              {
                title: "ケイマン諸島 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5mnG6O5",
                code: "Cayman Islands"
              },
              {
                title: "ケイマン諸島 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/0opLBXKOA",
                code: "Cayman Islands"
              }
            ],
            CW: [
              {
                title: "キュラソー 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVladVGyo",
                code: "Curacao"
              },
              {
                title: "キュラソー 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/796Dm3NkN",
                code: "Curacao"
              }
            ],
            GD: [
              {
                title: "グリナダ 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlb8Rl8Gv",
                code: "Grenada"
              },
              {
                title: "グリナダ 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llLXPmD4O",
                code: "Grenada"
              }
            ],
            HT: [
              {
                title: "ハイチ 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/829am2oln",
                code: "Haiti"
              },
              {
                title: "ハイチ 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/pVnA1X4lQ",
                code: "Haiti"
              }
            ],
            JM: [
              {
                title: "ジャマイカ 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnA1VB4w",
                code: "Jamaica"
              },
              {
                title: "ジャマイカ 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnXayz",
                code: "Jamaica"
              }
            ],
            TT: [
              {
                title: "トリニダード・トバゴ 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnAvl5X4",
                code: "Trinidad and Tobago"
              },
              {
                title: "トリニダード・トバゴ 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3badoQZK1",
                code: "Trinidad and Tobago"
              }
            ],
            TC: [
              {
                title: "タークスカイコス諸島 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVG1PVBDm",
                code: "Turks and Caicos Islands"
              },
              {
                title: "タークスカイコス諸島 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNd0KnkR",
                code: "Turks and Caicos Islands"
              }
            ],
            MQ: [
              {
                title: "フレンチマーティン 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQEmJB",
                code: "Martinique"
              },
              {
                title: "フレンチマーティン 1GB プラン",
                price: "NTD 699",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/G4OpLml0R",
                code: "Martinique"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            AI: [
              {
                title: "アンギラ 500MB プラン",
                price: "NTD 489",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbEmRb3NL",
                code: "Anguilla"
              },
              {
                title: "アンギラ 1GB プラン",
                price: "NTD 819",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENYQP4y1",
                code: "Anguilla"
              }
            ],
            VG: [
              {
                title: "イギリス領ヴァージン諸島 500MB プラン",
                price: "NTD 489",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmb0m8",
                code: "British Virgin Islands"
              },
              {
                title: "イギリス領ヴァージン諸島 1GB プラン",
                price: "NTD 819",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qd7oA1vl",
                code: "British Virgin Islands"
              }
            ],
            VC: [
              {
                title: "セントビンセント・グレナディーン 500MB プラン",
                price: "NTD 489",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYRLA573",
                code: "Saint Vincent and the Grenadines"
              },
              {
                title: "セントビンセント・グレナディーン 1GB プラン",
                price: "NTD 819",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1Pmgpe",
                code: "Saint Vincent and the Grenadines"
              }
            ],
            AR: [
              {
                title: "アルゼンチン 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Epz8L8dgL",
                code: "Argentina"
              },
              {
                title: "アルゼンチン 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLB0MXZV",
                code: "Argentina"
              },
              {
                title: "Argentina, Brazil, Peru 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmdPZm",
                code: "Argentina, Brazil, Peru"
              },
              {
                title: "Argentina, Brazil, Peru 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmArk37",
                code: "Argentina, Brazil, Peru"
              }
            ],
            BR: [
              {
                title: "ブラジル 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKYe301n",
                code: "Brazil"
              },
              {
                title: "ブラジル 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpYJa4MK",
                code: "Brazil"
              },
              {
                title: "Argentina, Brazil, Peru 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmdPZm",
                code: "Argentina, Brazil, Peru"
              },
              {
                title: "Argentina, Brazil, Peru 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmArk37",
                code: "Argentina, Brazil, Peru"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            PE: [
              {
                title: "ペルー 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aA063ZBk",
                code: "Peru"
              },
              {
                title: "ペルー 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlaevrpR",
                code: "Peru"
              },
              {
                title: "Argentina, Brazil, Peru 500MB プラン",
                price: "NTD 129",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmdPZm",
                code: "Argentina, Brazil, Peru"
              },
              {
                title: "Argentina, Brazil, Peru 1GB プラン",
                price: "NTD 249",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKmArk37",
                code: "Argentina, Brazil, Peru"
              }
            ],
            CO: [
              {
                title: "コロンビア 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796Dm9O3V",
                code: "Colombia"
              },
              {
                title: "コロンビア 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVladv3eo",
                code: "Colombia"
              }
            ],
            UY: [
              {
                title: "ウルグアイ 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3a6LELv",
                code: "Uruguay"
              },
              {
                title: "ウルグアイ 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVG1PmDDm",
                code: "Uruguay"
              }
            ],
            VE: [
              {
                title: "ベネズエラ 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZXmXdm7",
                code: "Venezuela"
              },
              {
                title: "ベネズエラ 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENYQP5VB",
                code: "Venezuela"
              }
            ],
            GY: [
              {
                title: "ガイアナ 500MB プラン",
                price: "NTD 159",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/okODLkaDe",
                code: "Guyana"
              },
              {
                title: "ガイアナ 1GB プラン",
                price: "NTD 309",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/9KXv9JQEr",
                code: "Guyana"
              }
            ],
            PA: [
              {
                title: "パナマ 500MB プラン",
                price: "NTD 219",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPz4DpMo",
                code: "Panama"
              },
              {
                title: "パナマ 1GB プラン",
                price: "NTD 399",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnXeO3",
                code: "Panama"
              }
            ],
            CL: [
              {
                title: "チリ 500MB プラン",
                price: "NTD 249",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDm4L91P",
                code: "Chile"
              },
              {
                title: "チリ 1GB プラン",
                price: "NTD 459",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/829am6m8P",
                code: "Chile"
              },
              {
                title: "Global 82 countries 10GB プラン",
                price: "NTD 2200",
                labels: ["1年", "10GB"],
                url: "https://dl.gl/2rNymeX4V",
                code: "Global 82 countries"
              }
            ],
            BO: [
              {
                title: "ボリビア 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKYAmmD4",
                code: "Bolivia"
              },
              {
                title: "ボリビア 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmRvaJ6m",
                code: "Bolivia"
              }
            ],
            CR: [
              {
                title: "コスタリカ 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0opLB05wA",
                code: "Costa Rica"
              },
              {
                title: "コスタリカ 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynl8wb5vg",
                code: "Costa Rica"
              }
            ],
            SR: [
              {
                title: "スリナム 500MB プラン",
                price: "NTD 339",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbEmRb9pd",
                code: "Suriname"
              },
              {
                title: "スリナム 1GB プラン",
                price: "NTD 579",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMZLGlOR",
                code: "Suriname"
              }
            ],
            EC: [
              {
                title: "エクアドル 500MB プラン",
                price: "NTD 369",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXYkNl3v",
                code: "Ecuador"
              },
              {
                title: "エクアドル 1GB プラン",
                price: "NTD 609",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5mnXzMV",
                code: "Ecuador"
              }
            ],
            DO: [
              {
                title: "ドミニカ共和国 500MB プラン",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYQE5L4",
                code: "The Dominican Republic"
              },
              {
                title: "ドミニカ共和国 1GB プラン",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5m4XBbg",
                code: "The Dominican Republic"
              }
            ],
            GT: [
              {
                title: "グアテマラ 500MB プラン",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3badobL8Q",
                code: "Guatemala"
              },
              {
                title: "グアテマラ 1GB プラン",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/796Dm3N2m",
                code: "Guatemala"
              }
            ],
            NI: [
              {
                title: "ニカラグア 500MB プラン",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ZENYDM1B4",
                code: "Nicaragua"
              },
              {
                title: "ニカラグア 1GB プラン",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDm4bpvr",
                code: "Nicaragua"
              }
            ],
            SV: [
              {
                title: "サルバドール 500MB プラン",
                price: "NTD 459",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeD9YekLn",
                code: "El Salvador"
              },
              {
                title: "サルバドール 1GB プラン",
                price: "NTD 789",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aKm1G9VO",
                code: "El Salvador"
              }
            ]
          }
        },
        USD: {
          en: {
            JP: [
              {
                title: "Japan Unlimited package",
                price: "USD 2",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/RLDzLpwJR"
              },
              {
                title: "Data Package Japan/Korea/ Unlimited",
                price: "USD 2.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/LL3zBgMrR"
              }
            ],
            KR: [
              {
                title: "Korea Unlimited package",
                price: "USD 2.5",
                labels: ["1 day", "Unlimited"]
              },
              {
                title: "Data Package Japan/Korea/ Unlimited",
                price: "USD 2.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/LL3zBgMrR"
              }
            ],
            TW: [
              {
                title: "Taiwan Unlimited package",
                price: "USD 2",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/Oo5zoPbDJ"
              }
            ],
            CN: [
              {
                title: "China 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbE6Abp6A"
              },
              {
                title: "China 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJOrprp"
              }
            ],
            HK: [
              {
                title: "Hong Kong  (China) 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Hong Kong  (China) Unlimited package",
                price: "USD 4.3",
                labels: ["1 day", "Unlimited"]
              }
            ],
            MO: [
              {
                title: "Macao (China) 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXzNKO2e"
              },
              {
                title: "Macao (China) 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/zeDNeQ0kb"
              }
            ],
            SG: [
              {
                title: "Singapore 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRozR4pz1"
              },
              {
                title: "Singapore Unlimited package",
                price: "USD 4.3",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/QVlzVB0oV"
              },
              {
                title: "Data Package SG/MY/TH/VN/ Unlimited",
                price: "USD 4.25",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnMYb5RE"
              }
            ],
            MY: [
              {
                title: "Malaysia 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Malaysia Unlimited package",
                price: "USD 4.3",
                labels: ["1 day", "Unlimited"]
              },
              {
                title: "Data Package SG/MY/TH/VN/ Unlimited",
                price: "USD 4.25",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnMYb5RE"
              }
            ],
            TH: [
              {
                title: "Thailand 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAnag61y"
              },
              {
                title: "Thailand Unlimited package",
                price: "USD 4.3",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/ynlKnQAOZ"
              },
              {
                title: "Data Package SG/MY/TH/VN/ Unlimited",
                price: "USD 4.25",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnMYb5RE"
              }
            ],
            VN: [
              {
                title: "VietNam 500MB package",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYBA5v6X"
              },
              {
                title: "VietNam Unlimited package",
                price: "USD 4.3",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNGdp7pO"
              },
              {
                title: "Data Package SG/MY/TH/VN/ Unlimited",
                price: "USD 4.25",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnMYb5RE"
              }
            ],
            ID: [
              {
                title: "Indonesia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGb1we3J"
              },
              {
                title: "Indonesia 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kLgEMOG43"
              }
            ],
            PH: [
              {
                title: "Philippines 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzmR3BR"
              },
              {
                title: "Philippines 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VY8zYB2NB"
              }
            ],
            KH: [
              {
                title: "Cambodia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OapYpmz"
              },
              {
                title: "Cambodia 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGbVQZNY"
              }
            ],
            LA: [
              {
                title: "Laos 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRozRGO5e"
              },
              {
                title: "Laos 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpK1zJw"
              }
            ],
            MM: [
              {
                title: "Myanmar 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVlzVMaN3"
              },
              {
                title: "Myanmar 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPOzg5VE"
              }
            ],
            IN: [
              {
                title: "India 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzm0gBr"
              },
              {
                title: "India 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llL3XnaKg"
              }
            ],
            IL: [
              {
                title: "Israel 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZwXNwzX"
              },
              {
                title: "Israel 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"]
              }
            ],
            BD: [
              {
                title: "Bangladesh 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4Oa4o25Z"
              },
              {
                title: "Bangladesh 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/0opZo26rk"
              }
            ],
            LK: [
              {
                title: "Sri Lanka 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz8QKPZ"
              },
              {
                title: "Sri Lanka 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VY8zYNB8B"
              }
            ],
            NP: [
              {
                title: "Nepal 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnMV9G44"
              },
              {
                title: "Nepal 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/pVnMA0dLX"
              }
            ],
            JO: [
              {
                title: "Jordan 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz2mpK4"
              },
              {
                title: "Jordan 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNGd9nkO"
              }
            ],
            MN: [
              {
                title: "Mongolia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2z8wv0M"
              },
              {
                title: "Mongolia 1GB package",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpBQAbv"
              }
            ],
            QA: [
              {
                title: "Qatar 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/vmb81DAp8"
              },
              {
                title: "Qatar 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3za0lQ1"
              }
            ],
            SA: [
              {
                title: "Saudi Arabia 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPOmQ9L0"
              },
              {
                title: "Saudi Arabia 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3zLMyvR"
              }
            ],
            BN: [
              {
                title: "Brunei 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796E979em"
              },
              {
                title: "Brunei 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5Rm0n4G"
              }
            ],
            MV: [
              {
                title: "Maldives 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Maldives 1GB package",
                price: "USD 13.3",
                labels: ["1 day", "1GB"]
              }
            ],
            BH: [
              {
                title: "Bahrain 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6abV4Q"
              },
              {
                title: "Bahrain 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGbV2AX4"
              }
            ],
            PK: [
              {
                title: "Pakistan 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baObM1Ne"
              },
              {
                title: "Pakistan 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5RG8YMG"
              }
            ],
            KZ: [
              {
                title: "Kazakhstan 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6mBZV7"
              },
              {
                title: "Kazakhstan 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPOz78B0"
              }
            ],
            AE: [
              {
                title: "UAE 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6a11kr"
              },
              {
                title: "UAE 1GB package",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aK6a1nZv"
              }
            ],
            AZ: [
              {
                title: "Azerbaijan 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3za0JJ1"
              },
              {
                title: "Azerbaijan 1GB package",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/796E97bbm"
              }
            ],
            AM: [
              {
                title: "Armenia 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpBvJ2L"
              },
              {
                title: "Armenia 1GB package",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llL35KXeR"
              }
            ],
            GE: [
              {
                title: "Georgia 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XvpzvAnKo"
              },
              {
                title: "Georgia 1GB package",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zoVmEr"
              }
            ],
            OM: [
              {
                title: "Oman 500MB package",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKzmlE1y"
              },
              {
                title: "Oman 1GB package",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zLkn2k"
              }
            ],
            KW: [
              {
                title: "Kuwait 500MB package",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4wZ6ODX7"
              },
              {
                title: "Kuwait 1GB package",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4wZ6OPmD"
              }
            ],
            TJ: [
              {
                title: "Tajikistan 500MB package",
                price: "USD 12.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlbz8E6Em"
              },
              {
                title: "Tajikistan 1GB package",
                price: "USD 20.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXzYZRDe"
              }
            ],
            AT: [
              {
                title: "Austria 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz84BGk"
              },
              {
                title: "Austria 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXzN6Klv"
              },
              {
                title: "Austria Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/gmPOz7nP0"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            BG: [
              {
                title: "Bulgaria 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAn094oM"
              },
              {
                title: "Bulgaria 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2z80dA1"
              },
              {
                title: "Bulgaria Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/AAYBRrob1"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            CH: [
              {
                title: "Switzerland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzL80aR"
              },
              {
                title: "Switzerland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Bpy8pG9Er"
              },
              {
                title: "Switzerland Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/1aK6mVorQ"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            CZ: [
              {
                title: "Czech Republic 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2zKlGVe"
              },
              {
                title: "Czech Republic 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4wZ4bDgB"
              },
              {
                title: "Czech Republic Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/9KX2Kg7mN"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            DE: [
              {
                title: "Germany 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/EpzKpmJmw"
              },
              {
                title: "Germany 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aK6abQk6"
              },
              {
                title: "Germany Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/796E9kEQm"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            DK: [
              {
                title: "Denmark 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXzNO59Z"
              },
              {
                title: "Denmark 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJ4rez2"
              },
              {
                title: "Denmark Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/Bpy8pnMy3"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            EE: [
              {
                title: "Estonia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNGr5YpV"
              },
              {
                title: "Estonia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZwbVQ99"
              },
              {
                title: "Estonia Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/5QdeQDyoR"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            ES: [
              {
                title: "Spain 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/rRwDRk76o"
              },
              {
                title: "Spain 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zobMwR"
              },
              {
                title: "Spain Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/YmKzmpekB"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            FI: [
              {
                title: "Finland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Oo5zLkeM3"
              },
              {
                title: "Finland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2z8gAb1"
              },
              {
                title: "Finland Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/DKLpK1BMK"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            FR: [
              {
                title: "France 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGbVQ4l5"
              },
              {
                title: "France 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/KbE6mnRAy"
              },
              {
                title: "France Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/brmJrQQE0"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            GB: [
              {
                title: "United Kingdom 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeDNe2D8G"
              },
              {
                title: "United Kingdom 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDzLlNyr"
              },
              {
                title: "United Kingdom Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/J4wZ4eym3"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            HR: [
              {
                title: "Croatia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Bpy8AQZ71"
              },
              {
                title: "Croatia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlza0M9l"
              },
              {
                title: "Croatia Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/RLDzm0GQl"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            IE: [
              {
                title: "Ireland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmJr1z0r"
              },
              {
                title: "Ireland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKpm7X3"
              },
              {
                title: "Ireland Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/EpzKpmmMw"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            IS: [
              {
                title: "Iceland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baOdR5d0"
              },
              {
                title: "Iceland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VY8zm0NZ2"
              },
              {
                title: "Iceland Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNGd85pO"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            IT: [
              {
                title: "Italy 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzmgBYJ"
              },
              {
                title: "Italy 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOb6keY"
              },
              {
                title: "Italy Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/4aAnaMOr0"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            LV: [
              {
                title: "Latvia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Xvpzv8pdK"
              },
              {
                title: "Latvia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/rRwDRlMP5"
              },
              {
                title: "Latvia Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/2rNGr5VyV"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            MT: [
              {
                title: "Malta 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Malta 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"]
              },
              {
                title: "Malta Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"]
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            NO: [
              {
                title: "Norway 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5RG85k5"
              },
              {
                title: "Norway 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baObMkVD"
              },
              {
                title: "Norway Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/zeDNeKZN4"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            PL: [
              {
                title: "Poland 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llL3lz41k"
              },
              {
                title: "Poland 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzEZDk0"
              },
              {
                title: "Poland Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/llL3lzQPE"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            PT: [
              {
                title: "Portugal 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKzmpMAR"
              },
              {
                title: "Portugal 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlza8pK3"
              },
              {
                title: "Portugal Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/vmb81NbVK"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            RO: [
              {
                title: "Romania 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2z8gA2l"
              },
              {
                title: "Romania 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/82932kLbV"
              },
              {
                title: "Romania Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/okO5klkb5"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            RU: [
              {
                title: "Russia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynlK8BoAn"
              },
              {
                title: "Russia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/8293aAym9"
              },
              {
                title: "Russia Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/EpzK8YKev"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            SE: [
              {
                title: "Sweden 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5QdeQgmRa"
              },
              {
                title: "Sweden 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8rz8QGoZ"
              },
              {
                title: "Sweden Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/gmPOmQXbe"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            SI: [
              {
                title: "Slovenia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNGrgoN4"
              },
              {
                title: "Slovenia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2zKlEv1"
              },
              {
                title: "Slovenia Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/EpzKpegOX"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            SK: [
              {
                title: "Slovakia 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baObgJbD"
              },
              {
                title: "Slovakia 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baObgNgm"
              },
              {
                title: "Slovakia Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/m1z21Q74V"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            TR: [
              {
                title: "Turkey 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgEMOgwQ"
              },
              {
                title: "Turkey 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8rz20Lbk"
              },
              {
                title: "Turkey Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/796EDapZl"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            UA: [
              {
                title: "Ukraine 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVlzVBlM0"
              },
              {
                title: "Ukraine 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb8mQkXL"
              },
              {
                title: "Ukraine Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/Nlbz8ERnO"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            LI: [
              {
                title: "Liechtenstein 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Liechtenstein 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okO5DEQM4"
              },
              {
                title: "Liechtenstein Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/9KX2vdg81"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            VA: [
              {
                title: "Vatican 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/VY8zYNk82"
              },
              {
                title: "Vatican 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2zKla6e"
              },
              {
                title: "Vatican Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/PVMzVkNz9"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            MC: [
              {
                title: "Monaco 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baObg3E0"
              },
              {
                title: "Monaco 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZwbJOz8"
              },
              {
                title: "Monaco Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/dRoz6X32K"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            AX: [
              {
                title: "Åland Islands 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGbV205m"
              },
              {
                title: "Åland Islands 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzEpRQ1"
              },
              {
                title: "Åland Islands Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"]
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            SM: [
              {
                title: "San Marino 500MB package",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmJrXNGK"
              },
              {
                title: "San Marino 1GB package",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJrXVo8"
              },
              {
                title: "San Marino Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/82932kmJE"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            NL: [
              {
                title: "Netherlands 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmJrXNyn"
              },
              {
                title: "Netherlands 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2zK3145"
              },
              {
                title: "Netherlands Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"]
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            BE: [
              {
                title: "Belgium 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6agNE6"
              },
              {
                title: "Belgium 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJrQ01K"
              },
              {
                title: "Belgium Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/okO5kQaow"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            LU: [
              {
                title: "Luxembourg 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlbz8Eo5v"
              },
              {
                title: "Luxembourg 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4wZ6O1Aa"
              },
              {
                title: "Luxembourg Unlimited package",
                price: "USD 9.4",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/0opZog5DE"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "Data Package Europe 35 countries/ Unlimited",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            CY: [
              {
                title: "Cyprus 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5RGKMG9"
              },
              {
                title: "Cyprus 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMzZBNJO"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            GR: [
              {
                title: "Greece 500MB package",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5QdeQDKEa"
              },
              {
                title: "Greece 1GB package",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYBAZlNX"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            HU: [
              {
                title: "Hungary 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baOdRPom"
              },
              {
                title: "Hungary 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGbL1arY"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            LT: [
              {
                title: "Lithuania 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6mVL8M"
              },
              {
                title: "Lithuania 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGb109yL"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            RS: [
              {
                title: "Serbia 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3zaevJv"
              },
              {
                title: "Serbia 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zL39z8"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            ME: [
              {
                title: "Montenegro 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz8yRB9"
              },
              {
                title: "Montenegro 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPOm4OVE"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            GG: [
              {
                title: "Guernsey 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4Oa4Eev6"
              },
              {
                title: "Guernsey 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNGrgp3A"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            JE: [
              {
                title: "Jersey 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPOmQPZo"
              },
              {
                title: "Jersey 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKpeVVL"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            IM: [
              {
                title: "Isle of man 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Isle of man 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"]
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            BA: [
              {
                title: "Bosnia and Herzegovina 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpKne7k"
              },
              {
                title: "Bosnia and Herzegovina 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpzvAZ88"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            GI: [
              {
                title: "Gibraltar 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmJrXrKm"
              },
              {
                title: "Gibraltar 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Nlbz8EmNk"
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            AL: [
              {
                title: "Albania 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Albania 1GB package",
                price: "USD 13.3",
                labels: ["1 day", "1GB"]
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            MK: [
              {
                title: "Macedonia 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Macedonia 1GB package",
                price: "USD 13.3",
                labels: ["1 day", "1GB"]
              },
              {
                title: "Data Package Europe 48 countries/ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "Data Package Europe 48 countries/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            EG: [
              {
                title: "Egypt 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKzY01ZN"
              },
              {
                title: "Egypt 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"]
              }
            ],
            MA: [
              {
                title: "Morocco 500MB package",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgEMvMaG"
              },
              {
                title: "Morocco 1GB package",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/796E9gMlN"
              }
            ],
            KE: [
              {
                title: "Kenya 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz8OD0v"
              },
              {
                title: "Kenya 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpK1mvv"
              }
            ],
            EH: [
              {
                title: "Western Sahara 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Bpy8pZJZe"
              },
              {
                title: "Western Sahara 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/0opZo3Voo"
              }
            ],
            GH: [
              {
                title: "Ghana 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAn0N2VM"
              },
              {
                title: "Ghana 1GB package",
                price: "USD 16",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynlKn4YV6"
              }
            ],
            ZA: [
              {
                title: "South Africa 500MB package",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzm0Rvm"
              },
              {
                title: "South Africa 1GB package",
                price: "USD 16",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKpeXAv"
              }
            ],
            MG: [
              {
                title: "Madagascar 500MB package",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5QdeQ6lGl"
              },
              {
                title: "Madagascar 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"]
              }
            ],
            DZ: [
              {
                title: "Algeria 500MB package",
                price: "USD 9.4",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Algeria 1GB package",
                price: "USD 17.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zoOya3"
              }
            ],
            ZM: [
              {
                title: "Zambia 500MB package",
                price: "USD 10.2",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYBR4zJB"
              },
              {
                title: "Zambia 1GB package",
                price: "USD 18.9",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baObMw9D"
              }
            ],
            MU: [
              {
                title: "Mauritius 500MB package",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/EpzK8P1Ky"
              },
              {
                title: "Mauritius 1GB package",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlzVBJE0"
              }
            ],
            NG: [
              {
                title: "Nigeria 500MB package",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KX2K8eJ4"
              },
              {
                title: "Nigeria 1GB package",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5RG8RyZ"
              }
            ],
            TN: [
              {
                title: "Tunisia 500MB package",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5Qde7RboB"
              },
              {
                title: "Tunisia 1GB package",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRoz6XrEK"
              }
            ],
            TZ: [
              {
                title: "Tanzania 500MB package",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Bpy8AQ2le"
              },
              {
                title: "Tanzania 1GB package",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJR0Zv8"
              }
            ],
            AO: [
              {
                title: "Angola 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Oo5zo2MlP"
              },
              {
                title: "Angola 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRozR920K"
              }
            ],
            AU: [
              {
                title: "Australia 500MB package",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgELQ3kP"
              },
              {
                title: "Australia 1GB package",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlzVB3lX"
              },
              {
                title: "Data Package New Zealand/Australia/Fiji/ 500M",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OaNepGO"
              },
              {
                title: "Data Package New Zealand/Australia/Fiji/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOVpz8e"
              }
            ],
            NZ: [
              {
                title: "New Zealand 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/okO5klL54"
              },
              {
                title: "New Zealand 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOb50Mg"
              },
              {
                title: "Data Package New Zealand/Australia/Fiji/ 500M",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OaNepGO"
              },
              {
                title: "Data Package New Zealand/Australia/Fiji/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOVpz8e"
              }
            ],
            FJ: [
              {
                title: "Fiji 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYBAgpA7"
              },
              {
                title: "Fiji 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNGrgAoO"
              },
              {
                title: "Data Package New Zealand/Australia/Fiji/ 500M",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OaNepGO"
              },
              {
                title: "Data Package New Zealand/Australia/Fiji/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOVpz8e"
              }
            ],
            GU: [
              {
                title: "Guam 500MB package",
                price: "USD 6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynlKn4yv6"
              },
              {
                title: "Guam 1GB package",
                price: "USD 11.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/NlbzlGJ6Q"
              },
              {
                title: "Data Package Guam/Saipan/ 500MB",
                price: "USD 5.95",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMz9dRz2"
              },
              {
                title: "Data Package Guam/Saipan/ 1GB",
                price: "USD 11.05",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKN6Yv8"
              }
            ],
            MP: [
              {
                title: "Saipan 500MB package",
                price: "USD 6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2zABYog"
              },
              {
                title: "Saipan 1GB package",
                price: "USD 11.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJOvDZw"
              },
              {
                title: "Data Package Guam/Saipan/ 500MB",
                price: "USD 5.95",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMz9dRz2"
              },
              {
                title: "Data Package Guam/Saipan/ 1GB",
                price: "USD 11.05",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKN6Yv8"
              }
            ],
            US: [
              {
                title: "United States 500MB package",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llL3lbr6E"
              },
              {
                title: "United States 1GB package",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpzvRJ6o"
              },
              {
                title: "Data Package United States/Canada/Mexico/ 500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpN3YRk"
              },
              {
                title: "Data Package United States/Canada/Mexico/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Xvpzr1m32"
              }
            ],
            CA: [
              {
                title: "Canada 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNGRo7Ke"
              },
              {
                title: "Canada 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDz6Owz4"
              },
              {
                title: "Data Package United States/Canada/Mexico/ 500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpN3YRk"
              },
              {
                title: "Data Package United States/Canada/Mexico/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Xvpzr1m32"
              }
            ],
            MX: [
              {
                title: "Mexico 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0opZK704P"
              },
              {
                title: "Mexico 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYBkDkB3"
              },
              {
                title: "Data Package United States/Canada/Mexico/ 500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpN3YRk"
              },
              {
                title: "Data Package United States/Canada/Mexico/ 1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Xvpzr1m32"
              }
            ],
            PR: [
              {
                title: "Puerto Rico 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3zLMwNM"
              },
              {
                title: "Puerto Rico 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/m1z2LyOwm"
              }
            ],
            GP: [
              {
                title: "Guadeloupe 500MB package",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbE6mnVNp"
              },
              {
                title: "Guadeloupe 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qde7R9Dr"
              }
            ],
            MF: [
              {
                title: "Saint Martin 500MB package",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgEMGZ29"
              },
              {
                title: "Saint Martin 1GB package",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzEKY9V"
              }
            ],
            AG: [
              {
                title: "Antigua and Barbuda 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/m1z21353Y"
              },
              {
                title: "Antigua and Barbuda 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4wZ4nJkR"
              }
            ],
            AW: [
              {
                title: "Aruba 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Aruba 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"]
              }
            ],
            KY: [
              {
                title: "Cayman Islands 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeDNeYlzO"
              },
              {
                title: "Cayman Islands 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/YmKzmle83"
              }
            ],
            CW: [
              {
                title: "Curacao 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/okO5kbORJ"
              },
              {
                title: "Curacao 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXzN66Vv"
              }
            ],
            GD: [
              {
                title: "Grenada 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/rRwDRQB2V"
              },
              {
                title: "Grenada 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGbVQBm7"
              }
            ],
            HT: [
              {
                title: "Haiti 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpKnNpw"
              },
              {
                title: "Haiti 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2zKlnrN"
              }
            ],
            JM: [
              {
                title: "Jamaica 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Bpy8pGDO6"
              },
              {
                title: "Jamaica 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpKnyaK"
              }
            ],
            TT: [
              {
                title: "Trinidad and Tobago 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRozeB2n1"
              },
              {
                title: "Trinidad and Tobago 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/0opZKGbKa"
              }
            ],
            TC: [
              {
                title: "Turks and Caicos Islands 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzL858K"
              },
              {
                title: "Turks and Caicos Islands 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzYRAnv"
              }
            ],
            MQ: [
              {
                title: "Martinique 500MB package",
                price: "USD 18",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVlzVBQZv"
              },
              {
                title: "Martinique 1GB package",
                price: "USD 30.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZwbJkK7"
              }
            ],
            AI: [
              {
                title: "Anguilla 500MB package",
                price: "USD 21.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/VY8zYkBOB"
              },
              {
                title: "Anguilla 1GB package",
                price: "USD 36.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMzVbQaO"
              }
            ],
            VG: [
              {
                title: "British Virgin Islands 500MB package",
                price: "USD 21.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPOmeNaD"
              },
              {
                title: "British Virgin Islands 1GB package",
                price: "USD 35.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qde7adaa"
              }
            ],
            VC: [
              {
                title: "Saint Vincent and the Grenadines 500MB package",
                price: "USD 21.6",
                labels: ["1 day", "500MB"]
              },
              {
                title: "Saint Vincent and the Grenadines 1GB package",
                price: "USD 36.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8rz8OamZ"
              }
            ],
            AR: [
              {
                title: "Argentina 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796E90BrP"
              },
              {
                title: "Argentina 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRozR44Je"
              },
              {
                title: "Data Package Argentina/Brazil/Peru/500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzrXANr"
              },
              {
                title: "Data Package Argentina/Brazil/Peru/1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAnkvPL0"
              }
            ],
            BR: [
              {
                title: "Brazil 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGbV23ab"
              },
              {
                title: "Brazil 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/m1z213QAm"
              },
              {
                title: "Data Package Argentina/Brazil/Peru/500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzrXANr"
              },
              {
                title: "Data Package Argentina/Brazil/Peru/1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAnkvPL0"
              }
            ],
            PE: [
              {
                title: "Peru 500MB package",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlbz8Epge"
              },
              {
                title: "Peru 1GB package",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/KbE6mnPmd"
              },
              {
                title: "Data Package Argentina/Brazil/Peru/500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzrXANr"
              },
              {
                title: "Data Package Argentina/Brazil/Peru/1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAnkvPL0"
              }
            ],
            CO: [
              {
                title: "Colombia 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpBvryL"
              },
              {
                title: "Colombia 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qde7K8Ll"
              }
            ],
            UY: [
              {
                title: "Uruguay 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKzmd16N"
              },
              {
                title: "Uruguay 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGb10Kve"
              }
            ],
            VE: [
              {
                title: "Venezuela 500MB package",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796E9kaom"
              },
              {
                title: "Venezuela 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnalGRy"
              }
            ],
            GY: [
              {
                title: "Guyana 500MB package",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OapY658"
              },
              {
                title: "Guyana 1GB package",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/8293aA9QA"
              }
            ],
            PA: [
              {
                title: "Panama 500MB package",
                price: "USD 9.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baObMOgv"
              },
              {
                title: "Panama 1GB package",
                price: "USD 17.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpKXynZ"
              }
            ],
            CL: [
              {
                title: "Chile 500MB package",
                price: "USD 11.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZwbJvZp"
              },
              {
                title: "Chile 1GB package",
                price: "USD 20.2",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zoVa6l"
              }
            ],
            BO: [
              {
                title: "Bolivia 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNGrgNw5"
              },
              {
                title: "Bolivia 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/KbE6b5nEv"
              }
            ],
            CR: [
              {
                title: "Costa Rica 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llL3XnwlB"
              },
              {
                title: "Costa Rica 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"]
              }
            ],
            SR: [
              {
                title: "Suriname 500MB package",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2z8DNpp"
              },
              {
                title: "Suriname 1GB package",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMzV5eBL"
              }
            ],
            EC: [
              {
                title: "Ecuador 500MB package",
                price: "USD 16",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXzyYNDl"
              },
              {
                title: "Ecuador 1GB package",
                price: "USD 27.2",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDzm0R0P"
              }
            ],
            DO: [
              {
                title: "The Dominican Republic 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8293aN2RY"
              },
              {
                title: "The Dominican Republic 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYBR4aAX"
              }
            ],
            GT: [
              {
                title: "Guatemala 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0opZLDz1N"
              },
              {
                title: "Guatemala 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/KbE6mnYZe"
              }
            ],
            NI: [
              {
                title: "Nicaragua 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGbV22Pb"
              },
              {
                title: "Nicaragua 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzEpZEE"
              }
            ],
            SV: [
              {
                title: "El Salvador 500MB package",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6a2obM"
              },
              {
                title: "El Salvador 1GB package",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kLgEL2ALP"
              }
            ]
          },
          ja: {
            JP: [
              {
                title: "日本 無制限",
                price: "USD 2",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/RLDzLpwJR"
              },
              {
                title: "日本/韓国",
                price: "USD 2.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/LL3zBgMrR"
              }
            ],
            KR: [
              {
                title: "韓国 無制限",
                price: "USD 2.5",
                labels: ["1 day", "無制限"]
              },
              {
                title: "日本/韓国",
                price: "USD 2.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/LL3zBgMrR"
              }
            ],
            TW: [
              {
                title: "台湾 無制限",
                price: "USD 2",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/Oo5zoPbDJ"
              }
            ],
            CN: [
              {
                title: "中国 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbE6Abp6A"
              },
              {
                title: "中国 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJOrprp"
              }
            ],
            HK: [
              {
                title: "香港 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"]
              },
              {
                title: "香港 無制限",
                price: "USD 4.3",
                labels: ["1 day", "無制限"]
              }
            ],
            MO: [
              {
                title: "マカオ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXzNKO2e"
              },
              {
                title: "マカオ 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/zeDNeQ0kb"
              }
            ],
            SG: [
              {
                title: "シンガポール 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRozR4pz1"
              },
              {
                title: "シンガポール 無制限",
                price: "USD 4.3",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/QVlzVB0oV"
              },
              {
                title:
                  "データチャージ シンガポール/ マレーシア/ タイ/ ベトナム/ /無制限プラン",
                price: "USD 4.25",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnMYb5RE"
              }
            ],
            MY: [
              {
                title: "マレーシア 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"]
              },
              {
                title: "マレーシア 無制限",
                price: "USD 4.3",
                labels: ["1 day", "無制限"]
              },
              {
                title:
                  "データチャージ シンガポール/ マレーシア/ タイ/ ベトナム/ /無制限プラン",
                price: "USD 4.25",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnMYb5RE"
              }
            ],
            TH: [
              {
                title: "タイ 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAnag61y"
              },
              {
                title: "タイ 無制限",
                price: "USD 4.3",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/ynlKnQAOZ"
              },
              {
                title:
                  "データチャージ シンガポール/ マレーシア/ タイ/ ベトナム/ /無制限プラン",
                price: "USD 4.25",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnMYb5RE"
              }
            ],
            VN: [
              {
                title: "ベトナム 500MB",
                price: "USD 3.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYBA5v6X"
              },
              {
                title: "ベトナム 無制限",
                price: "USD 4.3",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/2rNGdp7pO"
              },
              {
                title:
                  "データチャージ シンガポール/ マレーシア/ タイ/ ベトナム/ /無制限プラン",
                price: "USD 4.25",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/pVnMYb5RE"
              }
            ],
            ID: [
              {
                title: "インドネシア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGb1we3J"
              },
              {
                title: "インドネシア 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kLgEMOG43"
              }
            ],
            PH: [
              {
                title: "フィリピン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzmR3BR"
              },
              {
                title: "フィリピン 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VY8zYB2NB"
              }
            ],
            KH: [
              {
                title: "カンボジア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OapYpmz"
              },
              {
                title: "カンボジア 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGbVQZNY"
              }
            ],
            LA: [
              {
                title: "ラオス 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRozRGO5e"
              },
              {
                title: "ラオス 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpK1zJw"
              }
            ],
            MM: [
              {
                title: "ミャンマー 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVlzVMaN3"
              },
              {
                title: "ミャンマー 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPOzg5VE"
              }
            ],
            IN: [
              {
                title: "インド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzm0gBr"
              },
              {
                title: "インド 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llL3XnaKg"
              }
            ],
            IL: [
              {
                title: "イスラエル 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZwXNwzX"
              },
              {
                title: "イスラエル 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"]
              }
            ],
            BD: [
              {
                title: "バングラデシュ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4Oa4o25Z"
              },
              {
                title: "バングラデシュ 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/0opZo26rk"
              }
            ],
            LK: [
              {
                title: "スリランカ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz8QKPZ"
              },
              {
                title: "スリランカ 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VY8zYNB8B"
              }
            ],
            NP: [
              {
                title: "ネパール 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/pVnMV9G44"
              },
              {
                title: "ネパール 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/pVnMA0dLX"
              }
            ],
            JO: [
              {
                title: "ヨルダン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz2mpK4"
              },
              {
                title: "ヨルダン 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNGd9nkO"
              }
            ],
            MN: [
              {
                title: "モンゴル国 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2z8wv0M"
              },
              {
                title: "モンゴル国 1GB",
                price: "USD 6.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpBQAbv"
              }
            ],
            QA: [
              {
                title: "カタール 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/vmb81DAp8"
              },
              {
                title: "カタール 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3za0lQ1"
              }
            ],
            SA: [
              {
                title: "サウジアラビア 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPOmQ9L0"
              },
              {
                title: "サウジアラビア 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/LL3zLMyvR"
              }
            ],
            BN: [
              {
                title: "ブルネイ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796E979em"
              },
              {
                title: "ブルネイ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5Rm0n4G"
              }
            ],
            MV: [
              {
                title: "モルディブ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"]
              },
              {
                title: "モルディブ 1GB",
                price: "USD 13.3",
                labels: ["1 day", "1GB"]
              }
            ],
            BH: [
              {
                title: "バーレーン 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6abV4Q"
              },
              {
                title: "バーレーン 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGbV2AX4"
              }
            ],
            PK: [
              {
                title: "パキスタン 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baObM1Ne"
              },
              {
                title: "パキスタン 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5RG8YMG"
              }
            ],
            KZ: [
              {
                title: "カザフ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6mBZV7"
              },
              {
                title: "カザフ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPOz78B0"
              }
            ],
            AE: [
              {
                title: "アラブ首長国連邦 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6a11kr"
              },
              {
                title: "アラブ首長国連邦 1GB",
                price: "USD 13.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aK6a1nZv"
              }
            ],
            AZ: [
              {
                title: "アゼルバイジャン 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3za0JJ1"
              },
              {
                title: "アゼルバイジャン 1GB",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/796E97bbm"
              }
            ],
            AM: [
              {
                title: "アルメニア 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpBvJ2L"
              },
              {
                title: "アルメニア 1GB",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/llL35KXeR"
              }
            ],
            GE: [
              {
                title: "ジョージア 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/XvpzvAnKo"
              },
              {
                title: "ジョージア 1GB",
                price: "USD 13.8",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zoVmEr"
              }
            ],
            OM: [
              {
                title: "オマーン 500MB",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKzmlE1y"
              },
              {
                title: "オマーン 1GB",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zLkn2k"
              }
            ],
            KW: [
              {
                title: "クウェート 500MB",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/J4wZ6ODX7"
              },
              {
                title: "クウェート 1GB",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4wZ6OPmD"
              }
            ],
            TJ: [
              {
                title: "タジキスタン 500MB",
                price: "USD 12.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlbz8E6Em"
              },
              {
                title: "タジキスタン 1GB",
                price: "USD 20.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXzYZRDe"
              }
            ],
            AT: [
              {
                title: "オーストリア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz84BGk"
              },
              {
                title: "オーストリア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXzN6Klv"
              },
              {
                title: "オーストリア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/gmPOz7nP0"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            BG: [
              {
                title: "ブルガリア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAn094oM"
              },
              {
                title: "ブルガリア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2z80dA1"
              },
              {
                title: "ブルガリア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/AAYBRrob1"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            CH: [
              {
                title: "スイス 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzL80aR"
              },
              {
                title: "スイス 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Bpy8pG9Er"
              },
              {
                title: "スイス 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/1aK6mVorQ"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            CZ: [
              {
                title: "チェコ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2zKlGVe"
              },
              {
                title: "チェコ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4wZ4bDgB"
              },
              {
                title: "チェコ 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/9KX2Kg7mN"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            DE: [
              {
                title: "ドイツ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/EpzKpmJmw"
              },
              {
                title: "ドイツ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/1aK6abQk6"
              },
              {
                title: "ドイツ 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/796E9kEQm"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            DK: [
              {
                title: "デンマーク 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXzNO59Z"
              },
              {
                title: "デンマーク 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJ4rez2"
              },
              {
                title: "デンマーク 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/Bpy8pnMy3"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            EE: [
              {
                title: "エストニア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNGr5YpV"
              },
              {
                title: "エストニア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZwbVQ99"
              },
              {
                title: "エストニア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/5QdeQDyoR"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            ES: [
              {
                title: "スペイン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/rRwDRk76o"
              },
              {
                title: "スペイン 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zobMwR"
              },
              {
                title: "スペイン 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/YmKzmpekB"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            FI: [
              {
                title: "フィンランド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Oo5zLkeM3"
              },
              {
                title: "フィンランド 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2z8gAb1"
              },
              {
                title: "フィンランド 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/DKLpK1BMK"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            FR: [
              {
                title: "フランス 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGbVQ4l5"
              },
              {
                title: "フランス 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/KbE6mnRAy"
              },
              {
                title: "フランス 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/brmJrQQE0"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            GB: [
              {
                title: "イギリス 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeDNe2D8G"
              },
              {
                title: "イギリス 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDzLlNyr"
              },
              {
                title: "イギリス 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/J4wZ4eym3"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            HR: [
              {
                title: "クロアチア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Bpy8AQZ71"
              },
              {
                title: "クロアチア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlza0M9l"
              },
              {
                title: "クロアチア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/RLDzm0GQl"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            IE: [
              {
                title: "アイルランド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmJr1z0r"
              },
              {
                title: "アイルランド 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKpm7X3"
              },
              {
                title: "アイルランド 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/EpzKpmmMw"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            IS: [
              {
                title: "アイスランド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baOdR5d0"
              },
              {
                title: "アイスランド 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/VY8zm0NZ2"
              },
              {
                title: "アイスランド 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/2rNGd85pO"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            IT: [
              {
                title: "イタリア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzmgBYJ"
              },
              {
                title: "イタリア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOb6keY"
              },
              {
                title: "イタリア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/4aAnaMOr0"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            LV: [
              {
                title: "ラトビア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Xvpzv8pdK"
              },
              {
                title: "ラトビア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/rRwDRlMP5"
              },
              {
                title: "ラトビア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/2rNGr5VyV"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            MT: [
              {
                title: "マルタ共和国 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"]
              },
              {
                title: "マルタ共和国 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"]
              },
              {
                title: "マルタ共和国 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"]
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            NO: [
              {
                title: "ノルウェー 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5RG85k5"
              },
              {
                title: "ノルウェー 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baObMkVD"
              },
              {
                title: "ノルウェー 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/zeDNeKZN4"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            PL: [
              {
                title: "ポーランド 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llL3lz41k"
              },
              {
                title: "ポーランド 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzEZDk0"
              },
              {
                title: "ポーランド 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/llL3lzQPE"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            PT: [
              {
                title: "ポルトガル 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKzmpMAR"
              },
              {
                title: "ポルトガル 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlza8pK3"
              },
              {
                title: "ポルトガル 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/vmb81NbVK"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            RO: [
              {
                title: "ルーマニア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2z8gA2l"
              },
              {
                title: "ルーマニア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/82932kLbV"
              },
              {
                title: "ルーマニア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/okO5klkb5"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            RU: [
              {
                title: "ロシア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynlK8BoAn"
              },
              {
                title: "ロシア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/8293aAym9"
              },
              {
                title: "ロシア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/EpzK8YKev"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            SE: [
              {
                title: "スウェーデン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5QdeQgmRa"
              },
              {
                title: "スウェーデン 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8rz8QGoZ"
              },
              {
                title: "スウェーデン 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/gmPOmQXbe"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            SI: [
              {
                title: "スロベニア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNGrgoN4"
              },
              {
                title: "スロベニア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2zKlEv1"
              },
              {
                title: "スロベニア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/EpzKpegOX"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            SK: [
              {
                title: "スロバキア 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baObgJbD"
              },
              {
                title: "スロバキア 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baObgNgm"
              },
              {
                title: "スロバキア 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/m1z21Q74V"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            TR: [
              {
                title: "トルコ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgEMOgwQ"
              },
              {
                title: "トルコ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8rz20Lbk"
              },
              {
                title: "トルコ 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/796EDapZl"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            UA: [
              {
                title: "ウクライナ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVlzVBlM0"
              },
              {
                title: "ウクライナ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/vmb8mQkXL"
              },
              {
                title: "ウクライナ 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/Nlbz8ERnO"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            LI: [
              {
                title: "リヒテンシュタイン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"]
              },
              {
                title: "リヒテンシュタイン 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/okO5DEQM4"
              },
              {
                title: "リヒテンシュタイン 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/9KX2vdg81"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            VA: [
              {
                title: "バチカン 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/VY8zYNk82"
              },
              {
                title: "バチカン 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2zKla6e"
              },
              {
                title: "バチカン 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/PVMzVkNz9"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            MC: [
              {
                title: "モナコ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baObg3E0"
              },
              {
                title: "モナコ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZwbJOz8"
              },
              {
                title: "モナコ 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/dRoz6X32K"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            AX: [
              {
                title: "オーランド諸島 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGbV205m"
              },
              {
                title: "オーランド諸島 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzEpRQ1"
              },
              {
                title: "オーランド諸島 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"]
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            SM: [
              {
                title: "サンマリノ 500MB",
                price: "USD 3.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmJrXNGK"
              },
              {
                title: "サンマリノ 1GB",
                price: "USD 6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJrXVo8"
              },
              {
                title: "サンマリノ 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/82932kmJE"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            NL: [
              {
                title: "オランダ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmJrXNyn"
              },
              {
                title: "オランダ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2zK3145"
              },
              {
                title: "オランダ 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"]
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            BE: [
              {
                title: "ベルギー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6agNE6"
              },
              {
                title: "ベルギー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJrQ01K"
              },
              {
                title: "ベルギー 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/okO5kQaow"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            LU: [
              {
                title: "ルクセンブルグ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlbz8Eo5v"
              },
              {
                title: "ルクセンブルグ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4wZ6O1Aa"
              },
              {
                title: "ルクセンブルグ 無制限",
                price: "USD 9.4",
                labels: ["1 day", "無制限"],
                url: "https://dl.gl/0opZog5DE"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              },
              {
                title: "データチャージ ヨーロッパ35国/無制限プラン",
                price: "USD 9.5",
                labels: ["1 day", "Unlimited"],
                url: "https://dl.gl/8293odrlP"
              }
            ],
            CY: [
              {
                title: "キプロス 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/wG5RGKMG9"
              },
              {
                title: "キプロス 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMzZBNJO"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            GR: [
              {
                title: "ギリシャ 500MB",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5QdeQDKEa"
              },
              {
                title: "ギリシャ 1GB",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYBAZlNX"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            HU: [
              {
                title: "ハンガリー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baOdRPom"
              },
              {
                title: "ハンガリー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGbL1arY"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            LT: [
              {
                title: "リトアニア 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6mVL8M"
              },
              {
                title: "リトアニア 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGb109yL"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            RS: [
              {
                title: "セルビア 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3zaevJv"
              },
              {
                title: "セルビア 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zL39z8"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            ME: [
              {
                title: "モンテネグロ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz8yRB9"
              },
              {
                title: "モンテネグロ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/gmPOm4OVE"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            GG: [
              {
                title: "ガーンジー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4Oa4Eev6"
              },
              {
                title: "ガーンジー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNGrgp3A"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            JE: [
              {
                title: "ジャージー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPOmQPZo"
              },
              {
                title: "ジャージー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKpeVVL"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            IM: [
              {
                title: "マン島 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"]
              },
              {
                title: "マン島 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"]
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            BA: [
              {
                title: "ボスニア・ヘルツェゴビナ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpKne7k"
              },
              {
                title: "ボスニア・ヘルツェゴビナ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpzvAZ88"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            GI: [
              {
                title: "ジブラルタル 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/brmJrXrKm"
              },
              {
                title: "ジブラルタル 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Nlbz8EmNk"
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            AL: [
              {
                title: "アルバニア 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"]
              },
              {
                title: "アルバニア 1GB",
                price: "USD 13.3",
                labels: ["1 day", "1GB"]
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            MK: [
              {
                title: "マケドニア 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"]
              },
              {
                title: "マケドニア 1GB",
                price: "USD 13.3",
                labels: ["1 day", "1GB"]
              },
              {
                title: "データチャージ ヨーロッパ48国/500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8r2ynrZo"
              },
              {
                title: "データチャージ ヨーロッパ48国/1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnke80K"
              }
            ],
            EG: [
              {
                title: "エジプト 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKzY01ZN"
              },
              {
                title: "エジプト 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"]
              }
            ],
            MA: [
              {
                title: "モロッコ 500MB",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgEMvMaG"
              },
              {
                title: "モロッコ 1GB",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/796E9gMlN"
              }
            ],
            KE: [
              {
                title: "ケニア 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/e8rz8OD0v"
              },
              {
                title: "ケニア 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpK1mvv"
              }
            ],
            EH: [
              {
                title: "西サハラ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Bpy8pZJZe"
              },
              {
                title: "西サハラ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/0opZo3Voo"
              }
            ],
            GH: [
              {
                title: "ガーナ 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAn0N2VM"
              },
              {
                title: "ガーナ 1GB",
                price: "USD 16",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ynlKn4YV6"
              }
            ],
            ZA: [
              {
                title: "南アフリカ 500MB",
                price: "USD 8.5",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzm0Rvm"
              },
              {
                title: "南アフリカ 1GB",
                price: "USD 16",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKpeXAv"
              }
            ],
            MG: [
              {
                title: "マダガスカル 500MB",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5QdeQ6lGl"
              },
              {
                title: "マダガスカル 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"]
              }
            ],
            DZ: [
              {
                title: "アルジェリア 500MB",
                price: "USD 9.4",
                labels: ["1 day", "500MB"]
              },
              {
                title: "アルジェリア 1GB",
                price: "USD 17.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zoOya3"
              }
            ],
            ZM: [
              {
                title: "ザンビア 500MB",
                price: "USD 10.2",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYBR4zJB"
              },
              {
                title: "ザンビア 1GB",
                price: "USD 18.9",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baObMw9D"
              }
            ],
            MU: [
              {
                title: "モーリシャス 500MB",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/EpzK8P1Ky"
              },
              {
                title: "モーリシャス 1GB",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlzVBJE0"
              }
            ],
            NG: [
              {
                title: "ナイジェリア 500MB",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/9KX2K8eJ4"
              },
              {
                title: "ナイジェリア 1GB",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/wG5RG8RyZ"
              }
            ],
            TN: [
              {
                title: "チュニジア 500MB",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/5Qde7RboB"
              },
              {
                title: "チュニジア 1GB",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRoz6XrEK"
              }
            ],
            TZ: [
              {
                title: "タンザニア 500MB",
                price: "USD 13.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Bpy8AQ2le"
              },
              {
                title: "タンザニア 1GB",
                price: "USD 24.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJR0Zv8"
              }
            ],
            AO: [
              {
                title: "アンゴラ 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Oo5zo2MlP"
              },
              {
                title: "アンゴラ 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRozR920K"
              }
            ],
            AU: [
              {
                title: "オーストラリア 500MB",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgELQ3kP"
              },
              {
                title: "オーストラリア 1GB",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/QVlzVB3lX"
              },
              {
                title:
                  "データチャージ オーストラリア/ ニュージーランド/ フィジー /500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OaNepGO"
              },
              {
                title:
                  "データチャージ オーストラリア/ ニュージーランド/ フィジー /1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOVpz8e"
              }
            ],
            NZ: [
              {
                title: "ニュージーランド 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/okO5klL54"
              },
              {
                title: "ニュージーランド 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOb50Mg"
              },
              {
                title:
                  "データチャージ オーストラリア/ ニュージーランド/ フィジー /500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OaNepGO"
              },
              {
                title:
                  "データチャージ オーストラリア/ ニュージーランド/ フィジー /1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOVpz8e"
              }
            ],
            FJ: [
              {
                title: "フィジー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/AAYBAgpA7"
              },
              {
                title: "フィジー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/2rNGrgAoO"
              },
              {
                title:
                  "データチャージ オーストラリア/ ニュージーランド/ フィジー /500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OaNepGO"
              },
              {
                title:
                  "データチャージ オーストラリア/ ニュージーランド/ フィジー /1GB",
                price: "USD 9.35",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/3baOVpz8e"
              }
            ],
            GU: [
              {
                title: "グアム 500MB",
                price: "USD 6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/ynlKn4yv6"
              },
              {
                title: "グアム 1GB",
                price: "USD 11.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/NlbzlGJ6Q"
              },
              {
                price: "USD 5.95",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMz9dRz2"
              },
              {
                price: "USD 11.05",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKN6Yv8"
              }
            ],
            MP: [
              {
                title: "サイパン 500MB",
                price: "USD 6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2zABYog"
              },
              {
                title: "サイパン 1GB",
                price: "USD 11.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/brmJOvDZw"
              },
              {
                price: "USD 5.95",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/PVMz9dRz2"
              },
              {
                price: "USD 11.05",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/EpzKN6Yv8"
              }
            ],
            US: [
              {
                title: "アメリカ 500MB",
                price: "USD 4.3",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llL3lbr6E"
              },
              {
                title: "アメリカ 1GB",
                price: "USD 7.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/XvpzvRJ6o"
              },
              {
                title: "データチャージ アメリカ/ カナダ/ メキシコ /500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpN3YRk"
              },
              {
                title: "データチャージ アメリカ/ カナダ/ メキシコ /1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Xvpzr1m32"
              }
            ],
            CA: [
              {
                title: "カナダ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNGRo7Ke"
              },
              {
                title: "カナダ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDz6Owz4"
              },
              {
                title: "データチャージ アメリカ/ カナダ/ メキシコ /500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpN3YRk"
              },
              {
                title: "データチャージ アメリカ/ カナダ/ メキシコ /1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Xvpzr1m32"
              }
            ],
            MX: [
              {
                title: "メキシコ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0opZK704P"
              },
              {
                title: "メキシコ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYBkDkB3"
              },
              {
                title: "データチャージ アメリカ/ カナダ/ メキシコ /500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpN3YRk"
              },
              {
                title: "データチャージ アメリカ/ カナダ/ メキシコ /1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Xvpzr1m32"
              }
            ],
            PR: [
              {
                title: "プエルトリコ 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/LL3zLMwNM"
              },
              {
                title: "プエルトリコ 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/m1z2LyOwm"
              }
            ],
            GP: [
              {
                title: "グアドループ 500MB",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/KbE6mnVNp"
              },
              {
                title: "グアドループ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qde7R9Dr"
              }
            ],
            MF: [
              {
                title: "セントマーティン 500MB",
                price: "USD 9",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/kLgEMGZ29"
              },
              {
                title: "セントマーティン 1GB",
                price: "USD 15.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzEKY9V"
              }
            ],
            AG: [
              {
                title: "アンティグアバーブーダ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/m1z21353Y"
              },
              {
                title: "アンティグアバーブーダ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/J4wZ4nJkR"
              }
            ],
            AW: [
              {
                title: "アルバ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"]
              },
              {
                title: "アルバ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"]
              }
            ],
            KY: [
              {
                title: "ケイマン諸島 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/zeDNeYlzO"
              },
              {
                title: "ケイマン諸島 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/YmKzmle83"
              }
            ],
            CW: [
              {
                title: "キュラソー 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/okO5kbORJ"
              },
              {
                title: "キュラソー 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/aNXzN66Vv"
              }
            ],
            GD: [
              {
                title: "グリナダ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/rRwDRQB2V"
              },
              {
                title: "グリナダ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGbVQBm7"
              }
            ],
            HT: [
              {
                title: "ハイチ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpKnNpw"
              },
              {
                title: "ハイチ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/MK2zKlnrN"
              }
            ],
            JM: [
              {
                title: "ジャマイカ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Bpy8pGDO6"
              },
              {
                title: "ジャマイカ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpKnyaK"
              }
            ],
            TT: [
              {
                title: "トリニダード・トバゴ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/dRozeB2n1"
              },
              {
                title: "トリニダード・トバゴ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/0opZKGbKa"
              }
            ],
            TC: [
              {
                title: "タークスカイコス諸島 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzL858K"
              },
              {
                title: "タークスカイコス諸島 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzYRAnv"
              }
            ],
            MQ: [
              {
                title: "フレンチマーティン 500MB",
                price: "USD 18",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/QVlzVBQZv"
              },
              {
                title: "フレンチマーティン 1GB",
                price: "USD 30.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/6bZwbJkK7"
              }
            ],
            AI: [
              {
                title: "アンギラ 500MB",
                price: "USD 21.6",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/VY8zYkBOB"
              },
              {
                title: "アンギラ 1GB",
                price: "USD 36.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMzVbQaO"
              }
            ],
            VG: [
              {
                title: "イギリス領ヴァージン諸島 500MB",
                price: "USD 21.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/gmPOmeNaD"
              },
              {
                title: "イギリス領ヴァージン諸島 1GB",
                price: "USD 35.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qde7adaa"
              }
            ],
            VC: [
              {
                title: "セントビンセント・グレナディーン 500MB",
                price: "USD 21.6",
                labels: ["1 day", "500MB"]
              },
              {
                title: "セントビンセント・グレナディーン 1GB",
                price: "USD 36.6",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/e8rz8OamZ"
              }
            ],
            AR: [
              {
                title: "アルゼンチン 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796E90BrP"
              },
              {
                title: "アルゼンチン 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/dRozR44Je"
              },
              {
                title: "データチャージ アルゼンチン/ ブラジル/ ペルー /500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzrXANr"
              },
              {
                title: "データチャージ アルゼンチン/ ブラジル/ ペルー /1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAnkvPL0"
              }
            ],
            BR: [
              {
                title: "ブラジル 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGbV23ab"
              },
              {
                title: "ブラジル 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/m1z213QAm"
              },
              {
                title: "データチャージ アルゼンチン/ ブラジル/ ペルー /500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzrXANr"
              },
              {
                title: "データチャージ アルゼンチン/ ブラジル/ ペルー /1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAnkvPL0"
              }
            ],
            PE: [
              {
                title: "ペルー 500MB",
                price: "USD 5.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/Nlbz8Epge"
              },
              {
                title: "ペルー 1GB",
                price: "USD 9.4",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/KbE6mnPmd"
              },
              {
                title: "データチャージ アルゼンチン/ ブラジル/ ペルー /500MB",
                price: "USD 5.10",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/RLDzrXANr"
              },
              {
                title: "データチャージ アルゼンチン/ ブラジル/ ペルー /1GB",
                price: "USD 9.35",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/4aAnkvPL0"
              }
            ],
            CO: [
              {
                title: "コロンビア 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/DKLpBvryL"
              },
              {
                title: "コロンビア 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/5Qde7K8Ll"
              }
            ],
            UY: [
              {
                title: "ウルグアイ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/YmKzmd16N"
              },
              {
                title: "ウルグアイ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/nVGb10Kve"
              }
            ],
            VE: [
              {
                title: "ベネズエラ 500MB",
                price: "USD 6.8",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/796E9kaom"
              },
              {
                title: "ベネズエラ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/4aAnalGRy"
              }
            ],
            GY: [
              {
                title: "ガイアナ 500MB",
                price: "USD 7.7",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/G4OapY658"
              },
              {
                title: "ガイアナ 1GB",
                price: "USD 13.1",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/8293aA9QA"
              }
            ],
            PA: [
              {
                title: "パナマ 500MB",
                price: "USD 9.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/3baObMOgv"
              },
              {
                title: "パナマ 1GB",
                price: "USD 17.3",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/DKLpKXynZ"
              }
            ],
            CL: [
              {
                title: "チリ 500MB",
                price: "USD 11.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/6bZwbJvZp"
              },
              {
                title: "チリ 1GB",
                price: "USD 20.2",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/Oo5zoVa6l"
              }
            ],
            BO: [
              {
                title: "ボリビア 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/2rNGrgNw5"
              },
              {
                title: "ボリビア 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/KbE6b5nEv"
              }
            ],
            CR: [
              {
                title: "コスタリカ 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/llL3XnwlB"
              },
              {
                title: "コスタリカ 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"]
              }
            ],
            SR: [
              {
                title: "スリナム 500MB",
                price: "USD 15.1",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/MK2z8DNpp"
              },
              {
                title: "スリナム 1GB",
                price: "USD 25.5",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/PVMzV5eBL"
              }
            ],
            EC: [
              {
                title: "エクアドル 500MB",
                price: "USD 16",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/aNXzyYNDl"
              },
              {
                title: "エクアドル 1GB",
                price: "USD 27.2",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/RLDzm0R0P"
              }
            ],
            DO: [
              {
                title: "ドミニカ共和国 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/8293aN2RY"
              },
              {
                title: "ドミニカ共和国 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/AAYBR4aAX"
              }
            ],
            GT: [
              {
                title: "グアテマラ 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/0opZLDz1N"
              },
              {
                title: "グアテマラ 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/KbE6mnYZe"
              }
            ],
            NI: [
              {
                title: "ニカラグア 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/nVGbV22Pb"
              },
              {
                title: "ニカラグア 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/ZENzEpZEE"
              }
            ],
            SV: [
              {
                title: "サルバドール 500MB",
                price: "USD 20.4",
                labels: ["1 day", "500MB"],
                url: "https://dl.gl/1aK6a2obM"
              },
              {
                title: "サルバドール 1GB",
                price: "USD 34.7",
                labels: ["1 day", "1GB"],
                url: "https://dl.gl/kLgEL2ALP"
              }
            ]
          }
        }
      }
    };
  },
  methods: {
    changeTab(inputArea) {
      this.area = inputArea;
      for (let a in this.activeTab) {
        this.activeTab[a] = false;
      }
      this.activeTab[this.area] = true;
    },
    changeCountry(countryCode) {
      this.selectedCountry = countryCode;
    },
    changeLanguage(lang) {
      this.language = lang;
      // lang: this.$store.state.lang, // get lang 預設值 `en`
      console.log(this.$i18n.locale);
      this.$i18n.locale = lang;
      this.showLangList = false;
      this.selectedPlans = this.plans[this.currency][this.language]
        ? this.plans[this.currency][this.language]
        : this.plans[this.currency]["en"];
    },
    changeCurrency(currency) {
      this.currency = currency;
      this.showCurrencyList = false;
      this.selectedPlans = this.plans[this.currency][this.language]
        ? this.plans[this.currency][this.language]
        : this.plans[this.currency]["en"];
    },
    gotoPage(currency) {
      this.$router.push(currency); 
    },
    toggleLangList() {
      this.showLangList = !this.showLangList;
    },
    toggleCurrencyList() {
      this.showCurrencyList = !this.showCurrencyList;
    }
  },
  created() {
    // taiwan default
    this.changeLanguage("tw");
    this.changeCurrency("NTD");

    if (this.$route.query.d) {
      
      if (this.replaceMap[this.$route.query.d])
        this.distributor = this.$route.query.d;
    }
 
    // 海外 default
    // this.changeLanguage("en");
    // this.changeCurrency("USD");
  },
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 10px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
